// ============================================================
        //  1. Destiny核心库 & Material Library
        // ============================================================
        const TIAN_GAN = ['Jia', 'Yi', 'Bing', 'Ding', 'Wu', 'Ji', 'Geng', 'Xin', 'Ren', 'Gui'];
        const DI_ZHI = ['Zi', 'Chou', 'Yin', 'Mao', 'Chen', 'Si', 'Wu', 'Wei', 'Shen', 'You', 'Xu', 'Hai'];
        const WU_XING_GAN = { 'Jia': 'Wood', 'Yi': 'Wood', 'Bing': 'Fire', 'Ding': 'Fire', 'Wu': 'Earth', 'Ji': 'Earth', 'Geng': 'Metal', 'Xin': 'Metal', 'Ren': 'Water',
            'Gui': 'Water' };
        const WU_XING_ZHI = { 'Zi': 'Water', 'Chou': 'Earth', 'Yin': 'Wood', 'Mao': 'Wood', 'Chen': 'Earth', 'Si': 'Fire', 'Wu': 'Fire', 'Wei': 'Earth', 'Shen': 'Metal',
            'You': 'Metal', 'Xu': 'Earth', 'Hai': 'Water' };
        const XI_JI = {
            'Jia': { xi: 'Water, Wood', ji: 'Metal, Earth' },
            'Yi': { xi: 'Water, Wood', ji: 'Metal, Earth' },
            'Bing': { xi: 'Wood, Fire', ji: 'Water, Metal' },
            'Ding': { xi: 'Wood, Fire', ji: 'Water, Metal' },
            'Wu': { xi: 'Fire, Earth', ji: 'Wood, Water' },
            'Ji': { xi: 'Fire, Earth', ji: 'Wood, Water' },
            'Geng': { xi: 'Earth, Metal', ji: 'Fire, Wood' },
            'Xin': { xi: 'Earth, Metal', ji: 'Fire, Wood' },
            'Ren': { xi: 'Metal, Water', ji: 'Earth, Fire' },
            'Gui': { xi: 'Metal, Water', ji: 'Earth, Fire' }
        };
        // 修复：原代码多处调用 getXiJi(dayGan), 但从Wei定义该函数, 
        // 导致"Test Destiny"按钮点击后 JS 抛出 ReferenceError, 后续逻辑全部中断 (无报错提示, 看起来像"没反应") . 
        function getXiJi(dayGan) {
            return XI_JI[dayGan] || { xi: 'Wood, Fire', ji: 'Metal, Water' };
        }

        // ============================================================
        //  Destiny知识库 (Final Report用): Personality/Feng Shui/Zodiac/Chinese Zodiac/Zi Wei/Plain Talk
        // ============================================================
        const XING_GE = {
            'Jia': 'Jia Wood is Yang Wood, like a towering tree — upright, noble, a born leader, kind and tolerant, though sometimes stubborn.',
            'Yi': 'Yi Wood is Yin Wood, like vines and flowers — flexible and adaptable, empathetic with an artistic temperament, though sometimes indecisive.',
            'Bing': 'Bing Fire is Yang Fire, like the blazing midday sun — passionate, generous and open-hearted, though sometimes impatient and impulsive.',
            'Ding': 'Ding Fire is Yin Fire, like the glow of a candle — gentle and delicate, meticulous in thought, though sometimes suspicious and sensitive.',
            'Wu': 'Wu Earth is Yang Earth, like high mountains and thick soil — honest, steady and trustworthy, though sometimes stubborn and conservative.',
            'Ji': 'Ji Earth is Yin Earth, like fertile garden soil — gentle, pragmatic and good at planning, though sometimes overly cautious.',
            'Geng': 'Geng Metal is Yang Metal, like swords and steel — resolute and decisive with great drive, though sometimes too rigid.',
            'Xin': 'Xin Metal is Yin Metal, like fine jewelry — refined and delicate with excellent taste, though sometimes too perfectionist.',
            'Ren': 'Ren Water is Yang Water, like rivers and oceans — wise, profound, open-minded and free-spirited, though sometimes too easygoing.',
            'Gui': 'Gui Water is Yin Water, like gentle rain and dew — soft, delicate and spiritual, though sometimes overly emotional.'
        };
        function getFengShuiAdvice(dayGan, wuXingCount) {
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            let maxWx = '', maxCount = 0,
                minWx = '', minCount = 999;
            for (const [wx, cnt] of Object.entries(wuXingCount)) {
                if (cnt > maxCount) { maxCount = cnt; maxWx = wx; }
                if (cnt < minCount) { minCount = cnt; minWx = wx; }
            }
            const advices = [];
            const fangWei = { 'Wood': 'East, Southeast', 'Fire': 'South', 'Earth': 'Center, Southwest', 'Metal': 'West, Northwest', 'Water': 'North' };
            const xiFang = xiList.map(w => fangWei[w] || '').filter(Boolean);
            if (xiFang.length) advices.push(`🏠 Favor orientations or layouts in the  <strong>${xiFang.join(', ')}</strong>  direction.`);
            const yanSe = { 'Wood': 'green, cyan', 'Fire': 'red, purple', 'Earth': 'yellow, brown', 'Metal': 'white, gold', 'Water': 'blue, black' };
            const xiSe = xiList.map(w => yanSe[w] || '').filter(Boolean);
            if (xiSe.length) advices.push(`🎨 Use more of the <strong>${xiSe.join(', ')}</strong>  tones to help boost your luck.`);
            const hangYe = { 'Wood': 'education, culture, medicine', 'Fire': 'energy, food, technology', 'Earth': 'real estate, construction, management', 'Metal': 'finance, law, jewelry', 'Water': 'logistics, trade, tourism' };
            const xiHang = xiList.map(w => hangYe[w] || '').filter(Boolean);
            if (xiHang.length) advices.push(`💼 Engage in <strong>${xiHang.join(', ')}</strong>  industries for easier success.`);
            if (maxWx && minWx) {
                if (maxCount >= 3) advices.push(`⚖️ ${maxWx} is excessive — balance it with the  ${jiList.join(', ')}  element.`);
                if (minCount <= 1) advices.push(`🌟 ${minWx} is weak — reinforce it with the  ${xiList.join(', ')}  element.`);
            }
            advices.push('🧘 Keep a calm mindset, regularly clear your living space, and ensure good light and air flow.');
            return advices;
        }
        function getMingLiAnalysis(dayGan, wuXingCount, pillars) {
            const xingGe = XING_GE[dayGan] || 'Gentle personality, sincere to others. ';
            const xiJi = getXiJi(dayGan);
            const sorted = Object.entries(wuXingCount).sort((a, b) => b[1] - a[1]);
            const strongest = sorted[0] ? sorted[0][0] : 'Earth';
            const weakest = sorted[sorted.length - 1] ? sorted[sorted.length - 1][0] : 'Water';
            const lines = [];
            lines.push(`<strong>Day Master: </strong>${dayGan} (${WU_XING_GAN[dayGan]}) `);
            lines.push(`<strong>Personality: </strong>${xingGe}`);
            lines.push(`<strong>Five Elements Favorable/Avoid: </strong>Favorable <span class="hl">${xiJi.xi}</span>, Avoid <span class="hl">${xiJi.ji}</span>`);
            lines.push(`<strong>Element Strength: </strong>${strongest}  strongest, ${weakest}  weakest.`);
            lines.push(`<strong>Fortune Advice: </strong>engage more with <span class="hl">${xiJi.xi}</span>  related things, and avoid over-indulging in <span class="hl">${xiJi.ji}</span>  environments.`);
            const dayZhi = pillars.day.zhi;
            lines.push(`<strong>Day Branch Element: </strong>${dayZhi} (${WU_XING_ZHI[dayZhi] || 'Earth'}) ,  has a Generating/Controlling effect on the Day Master.`);
            const allGan = [pillars.year.gan, pillars.month.gan, pillars.day.gan, pillars.hour.gan];
            const allZhi = [pillars.year.zhi, pillars.month.zhi, pillars.day.zhi, pillars.hour.zhi];
            const allWx = [...allGan.map(g => WU_XING_GAN[g]), ...allZhi.map(z => WU_XING_ZHI[z])];
            const wxCount2 = {};
            allWx.forEach(w => { wxCount2[w] = (wxCount2[w] || 0) + 1; });
            let mostWx = '', mostNum = 0;
            for (const [w, c] of Object.entries(wxCount2)) { if (c > mostNum) { mostNum = c; mostWx = w; } }
            lines.push(`<strong>Chart Pattern: </strong>In your BaZi,  <span class="hl">${mostWx}</span>  is the strongest element, tilting the whole chart toward a  ${mostWx}  pattern.`);
            return lines;
        }

        const ZODIAC_DESC_CN = {
            'Aries': 'Full of energy, brave and direct, you love a challenge. You are a born pioneer with strong drive, though sometimes too impatient.',
            'Taurus': 'Steady and pragmatic, you enjoy life and have great patience. You value security and beauty, though sometimes too stubborn.',
            'Gemini': 'Smart and curious, you communicate well and adapt quickly. Your mind is flexible, though you sometimes get distracted.',
            'Cancer': 'Gentle and caring, emotionally rich, you treasure family. You have a strong protective instinct, though sometimes overly emotional.',
            'Leo': 'Confident and generous, warm-hearted with natural leadership. You enjoy the spotlight, though sometimes self-centered.',
            'Virgo': 'Meticulous and rigorous, you pursue perfection and excel at analysis. You work seriously, though sometimes too picky.',
            'Libra': 'Elegant and fair, sociable, you seek harmony. You have refined taste, though sometimes indecisive.',
            'Scorpio': 'Deep and perceptive with strong willpower and keen insight. Your emotions run intense, though sometimes possessive.',
            'Sagittarius': 'Optimistic and cheerful, you love freedom and adventure. You are broad-minded, though sometimes not careful enough.',
            'Capricorn': 'Down-to-earth and diligent with a strong sense of responsibility and clear goals. You have great endurance, though sometimes too serious.',
            'Aquarius': 'Independent and innovative with a progressive mind and humanitarian spirit. You are unique, though sometimes seem detached.',
            'Pisces': 'Empathetic and imaginative with delicate emotions. You have artistic talent, though sometimes too idealistic.'
        };
        const ZODIAC_DETAILS_CN = {
            'Aries': { love: 'In love you are direct and proactive, enjoying the thrill of the chase. Remember to give your partner room to express themselves.', career: 'You thrive in pioneering, competitive work — startups or sales roles bring out your strengths.', money: 'You tend to spend freely; building a savings plan will help you avoid impulse purchases.', health: 'You have abundant energy, but impatience can cause headaches or inflammation — balance work and rest.', advice: 'Think for three more seconds before acting — it makes your actions far more powerful.' },
            'Taurus': { love: 'You are devoted and loyal, preferring stable, comfortable relationships, and you show love through actions.', career: 'You suit work requiring patience and precision — finance, accounting, gardening, or the arts.', money: 'A natural money manager, though you occasionally splurge to enjoy life — plan sensibly and you are set.', health: 'Take care of your neck and throat, and avoid overly cold food and drink.', advice: 'Breaking your routine now and then will reveal a different view.' },
            'Gemini': { love: 'You seek a meeting of minds, love chatting and sharing new things with your partner, and need plenty of personal space.', career: 'You suit media, education, sales, writing — work that needs communication and adaptability.', money: 'You have diverse income streams but also high spending — learn to track and plan.', health: 'Your nervous system tenses easily — ensure enough sleep and practice deep breathing.', advice: 'Focus on one goal — depth is more valuable than breadth.' },
            'Cancer': { love: 'Gentle and caring, you put family first and need a partner who gives you a strong sense of security.', career: 'You suit nurturing work — education, nursing, hospitality, or home design.', money: 'A good saver, though you tend to overspend on family and household needs.', health: 'Emotional swings affect your digestion — learning to release emotions is important.', advice: 'Care for your own needs first, then you can care for others better.' },
            'Leo': { love: 'Passionate and romantic, you love being adored and valued, and would give everything for your loved one.', career: 'You suit fields that showcase your charisma — management, performance, PR, or fashion.', money: 'Generous and fond of quality things — watch out for impulse spending.', health: 'Pay special attention to your heart and spine, and avoid overwork.', advice: 'A true leader listens, not just commands.' },
            'Virgo': { love: 'Refined and considerate, you pursue perfection in love, sometimes agonizing over details.', career: 'You suit precise work — data analysis, editing, medicine, or services.', money: 'A good planner with steady investments, though perfectionism can make you hesitate.', health: 'Your digestive system is weaker — eat regularly and avoid excessive anxiety.', advice: 'Accept imperfection and life becomes lighter.' },
            'Libra': { love: 'You value partnership, excel at creating romance and harmony, and fear conflict.', career: 'You suit work needing coordination — law, PR, design, or human resources.', money: 'You spend rationally, though sometimes overspend to maintain a social image.', health: 'Take care of your kidneys and lower back, and exercise moderately.', advice: 'Learning to say "no" is the start of protecting your energy.' },
            'Scorpio': { love: 'You love deeply and exclusively, seeking a soul-level bond, with strong possessiveness and insight.', career: 'You suit deep-dive fields — investigation, finance, psychology, or research.', money: 'You have a keen eye for investment and build wealth well, though sometimes too risky.', health: 'Care for your reproductive system — suppressed emotions affect your hormones.', advice: 'Letting go of obsession and trusting others is also a strength.' },
            'Sagittarius': { love: 'You cherish freedom, love exploring the world with your partner, and hate feeling tied down.', career: 'You suit work that lets you roam — travel, education, philosophy, or trade.', money: 'You spend freely, often paying for interests and experiences — set a budget.', health: 'Watch your legs and liver, and avoid over-exercising.', advice: 'Build freedom on responsibility and you will fly even further.' },
            'Capricorn': { love: 'Steady and pragmatic, you value responsibility and commitment in love, and are not one for sweet talk.', career: 'You suit fields built on long-term effort — management, administration, law, or architecture.', money: 'A master of finance with great long-term planning and ample late-life wealth.', health: 'Care for your bones and knees, and avoid sitting still for too long.', advice: 'Work matters, but enjoying life is equally essential.' },
            'Aquarius': { love: 'You seek a spiritual partner and value friendship and equality in love, though you sometimes seem detached.', career: 'You suit cutting-edge or niche fields — technology, innovation, charity, or astronomy.', money: 'Not very materialistic, though learning basic finance is recommended.', health: 'Watch your circulation and nervous system, and take part in group activities.', advice: 'Your uniqueness is exactly your charm — no need to please everyone.' },
            'Pisces': { love: 'Romantic and dreamy, you long for a fairytale love.', career: 'You suit fields needing creativity and empathy — art, music, counseling, or charity.', money: 'Your money sense is vague and you easily pay for sentiment — consider delegating management to someone reliable.', health: 'Care for your feet and sleep quality, and learn to shield out negative energy.', advice: 'Guard your boundaries — be gentle with others, and gentle with yourself.' }
        };
        const ZODIAC_CHINESE_DESC = {
            'Rat': 'Clever and quick-witted, highly adaptable and sociable. Good fortune with money, though sometimes too calculating.',
            'Ox': 'Diligent and down-to-earth, honest and patient. A stable career, though a bit stubborn in love.',
            'Tiger': 'Brave and confident, full of vitality and leadership. Watch your temper and avoid impulsiveness.',
            'Rabbit': 'Gentle and kind, delicate-minded with an artistic temperament. Good relationships, though prone to melancholy.',
            'Dragon': 'Ambitious and charismatic with a pioneering spirit. Prosperous fortune, though stay focused.',
            'Snake': 'Wise and deep, a thoughtful soul with an air of mystery. Good fortune, though sometimes overly cautious.',
            'Horse': 'Passionate and unrestrained, free-spirited with strong drive. Your career rises fast, though patience may be lacking.',
            'Goat': 'Gentle and inclusive, compassionate and family-oriented. Steady fortune suits stable development.',
            'Monkey': 'Clever and witty, humorous and adaptable. Your fortune fluctuates — beware of ill-intentioned people.',
            'Rooster': 'Diligent and honest, a good planner with responsibility. Career success, though communicate more in love.',
            'Dog': 'Loyal and upright with a strong sense of justice, highly trustworthy. Stable fortune and a harmonious family.',
            'Pig': 'Generous and kind-hearted, optimistic and blessed. Good fortune, though practice moderation.'
        };
        const ZODIAC_EMOJI_ANIMAL = { 'Rat': '🐭', 'Ox': '🐮', 'Tiger': '🐯', 'Rabbit': '🐰', 'Dragon': '🐲', 'Snake': '🐍', 'Horse': '🐴', 'Goat': '🐏', 'Monkey': '🐵', 'Rooster': '🐔', 'Dog': '🐶', 'Pig': '🐷' };

        const ZIWEI_MAIN_STAR = { 'Jia': 'Zi Wei', 'Yi': 'Tian Ji', 'Bing': 'Tai Yang', 'Ding': 'Wu Qu', 'Wu': 'Tian Tong', 'Ji': 'Lian Zhen', 'Geng': 'Tian Fu', 'Xin': 'Tai Yin', 'Ren': 'Tan Lang', 'Gui': 'Ju Men' };
        const ZIWEI_STARS = {
            'Zi Wei': { wuxing: 'Ji Earth', yinyang: 'Yin', huaqi: 'Honor', xingxing: 'The pivot of all stars, known as the Emperor Star — transforms into nobility, resolving misfortune and calamity.', desc: 'Honest-looking with refined manners, courteous to others, cautious and composed. You like giving orders, are easily swayed by flattery, and can be somewhat ruthless.', career: 'You suit management and leadership roles with an emperor’s bearing, but beware the loneliness at the top.', love: 'In love you are more passive and need the other party to make the first move.', advice: 'Learn to listen to others and avoid acting arbitrarily.' },
            'Tian Ji': { wuxing: 'Yi Wood', yinyang: 'Yin', huaqi: 'Virtue', xingxing: 'The Star of Wisdom — transforms into goodness, governing intelligence and flexibility.', desc: 'You love using your mind, are quick to understand with strong research instincts, agile, highly intelligent and perceptive, though sometimes crafty and fond of clever tricks.', career: 'You suit work requiring intellect — planning, consulting, education, or research.', love: 'In love you enjoy intellectual connection and need a partner who can keep up with your mind.', advice: 'Focus on one direction and avoid spreading your energy too thin.' },
            'Tai Yang': { wuxing: 'Bing Fire', yinyang: 'Yang', huaqi: 'Nobility', xingxing: 'The Star of Light — transforms into nobility, governing passion, generosity and universal love.', desc: 'Full-faced and sturdy, forthright and kind-hearted, clear about likes and dislikes, passionate and devoted in love, warm toward others and respected by friends.', career: 'You suit fields needing warmth and charisma — charity, education, performance, or PR.', love: 'In love you are passionate and proactive, though sometimes too self-focused.', advice: 'Learn to care for yourself and avoid burning out.' },
            'Wu Qu': { wuxing: 'Xin Metal', yinyang: 'Yin', huaqi: 'Wealth', xingxing: 'The Star of Wealth — transforms into firmness, governing wealth, martial courage and obstinacy.', desc: 'Fierce and solitary in temperament, slightly impatient, with some turbulence in marriage, yet blessed with lifelong wealth — if you strive upward and stay thrifty, great wealth will come after middle age.', career: 'You suit fields needing decisiveness and execution — finance, management, military/police, or engineering.', love: 'In love you are pragmatic and not good at expressing tenderness.', advice: 'Cultivate a softer side and avoid being too rigid.' },
            'Tian Tong': { wuxing: 'Ren Water', yinyang: 'Yang', huaqi: 'Blessing', xingxing: 'The Star of Blessing — transforms into fortune, governing gentleness, kindness and contentment.', desc: 'Round-faced and gentle, full of vitality, courteous, appreciative of life’s pleasures, well-versed in letters and fond of study, though you struggle to persist.', career: 'You suit fields needing gentleness and patience — service, education, or the arts.', love: 'In love you are tender and caring, though lacking passion.', advice: 'Build perseverance and turn interests into expertise.' },
            'Lian Zhen': { wuxing: 'Ding Fire', yinyang: 'Yin', huaqi: 'Restraint', xingxing: 'The Star of Spirit — transforms into restraint, governing integrity, intelligence and pride.', desc: 'Physically strong and stubborn, quick-tempered, often acting on impulse and going your own way, yet still possessing tenacity and diligence.', career: 'You suit fields needing principle and courage — law, military/police, or management.', love: 'In love you are clear-cut about feelings, with strong possessiveness.', advice: 'Learn to control your emotions and avoid regrets from impulsiveness.' },
            'Tian Fu': { wuxing: 'Wu Earth', yinyang: 'Yang', huaqi: 'Wisdom', xingxing: 'The Chief Star of the Southern Dipper — transforms into wisdom, governing wealth, property and management.', desc: 'Refined and accomplished, broad-minded, with helpful mentors throughout life, though prone to laziness and lacking the passion and drive to pioneer.', career: 'You suit fields needing steadiness and planning — management, administration, or real estate.', love: 'In love you are stable and reliable, though lacking romance.', advice: 'Step out of your comfort zone and try new possibilities.' },
            'Tai Yin': { wuxing: 'Gui Water', yinyang: 'Yin', huaqi: 'Wealth', xingxing: 'The Star of Purity — transforms into wealth, governing gentleness, delicacy and romance.', desc: 'Elegant and refined with fine features, gentle in nature, learned and versatile, naturally romantic with irresistible charm, though with a tendency to escape reality.', career: 'You suit fields needing sensibility and aesthetics — art, design, or counseling.', love: 'In love you are romantic and affectionate, though prone to fantasy.', advice: 'Stay grounded and avoid over-idealizing.' },
            'Tan Lang': { wuxing: 'Jia Wood', yinyang: 'Yang', huaqi: 'Romance', xingxing: 'The Star of Yang Light — transforms into romance, governing desire, material things and surprises.', desc: 'Possessive and fond of change, worldly and smooth, pleasure-loving with many indulgences, especially drawn to wine and romance.', career: 'You suit fields needing charm and connections — entertainment, socializing, or the arts.', love: 'In love you are passionate and unrestrained, though prone to shifting affections.', advice: 'Cultivate self-discipline and avoid indulging in pleasure.' },
            'Ju Men': { wuxing: 'Gui Water', yinyang: 'Yin', huaqi: 'Darkness', xingxing: 'The Star of Yin Essence — transforms into darkness, governing debate, disputes and eloquence.', desc: 'Eloquent and articulate, yet strongly opinionated, deep-minded, suspicious and cold, easily becoming short-sighted.', career: 'You suit fields needing eloquence and debate — law, journalism, or diplomacy.', love: 'In love your words can be sharp — learn to express yourself more gently.', advice: 'Watch your words and avoid bringing trouble through speech.' }
        };

        // Plain Talk解读：Career/Health/Love/Study/Wealth 五个维度
        function getZhiRelation(gan, zhi) {
            const gWx = WU_XING_GAN[gan],
                zWx = WU_XING_ZHI[zhi];
            const sheng = { 'Wood': 'Fire', 'Fire': 'Earth', 'Earth': 'Metal', 'Metal': 'Water', 'Water': 'Wood' };
            const ke = { 'Wood': 'Earth', 'Earth': 'Water', 'Water': 'Fire', 'Fire': 'Metal', 'Metal': 'Wood' };
            if (sheng[gWx] === zWx) return 'a Generating (release) relationship';
            if (sheng[zWx] === gWx) return 'a Generating (support) relationship';
            if (ke[gWx] === zWx) return 'a Controlling (you control) relationship';
            if (ke[zWx] === gWx) return 'a Controlling (controls you) relationship';
            if (gWx === zWx) return 'a Harmonizing (same element) relationship';
            return 'a Neutral relationship';
        }
        function generatePlainChineseText(dayGan, wuXingCount, pillars) {
            const dayWx = WU_XING_GAN[dayGan] || 'Earth';
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const sorted = Object.entries(wuXingCount).sort((a, b) => b[1] - a[1]);
            const strong = sorted[0] ? sorted[0][0] : 'Earth',
                weak = sorted[sorted.length - 1] ? sorted[sorted.length - 1][0] : 'Water';
            const strongCount = wuXingCount[strong] || 0,
                weakCount = wuXingCount[weak] || 0;
            const dayZhi = pillars.day.zhi,
                dayZhiWx = WU_XING_ZHI[dayZhi] || 'Earth';
            const industryMap = { 'Wood': 'education, culture, forestry, medicine', 'Fire': 'energy, food, technology, media', 'Earth': 'real estate, construction, agriculture, management', 'Metal': 'finance, law, machinery, jewelry', 'Water': 'logistics, trade, tourism, fishery' };
            const colorMap = { 'Wood': 'green, cyan', 'Fire': 'red, purple', 'Earth': 'yellow, brown', 'Metal': 'white, gold', 'Water': 'blue, black' };
            const directionMap = { 'Wood': 'East, Southeast', 'Fire': 'South', 'Earth': 'Center, Southwest', 'Metal': 'West, Northwest', 'Water': 'North' };

            let career = `Your career development favors the "${xiList.join(', ')}" element.`;
            const inds = xiList.map(w => industryMap[w] || '').filter(Boolean);
            if (inds.length) career += `You are suited to industries such as  ${inds.join(', ')} , `;
            if (strongCount >= 3) career += `In your BaZi, "${strong}" is excessive — at work, avoid being too stubborn or rash, and keep a balance.`;
            else if (weakCount <= 1) career += `"${weak}" is weak — add more  ${colorMap[weak] || ''}  tones to your workspace, or choose a position in the  ${directionMap[weak] || ''}  direction to compensate.`;
            else career += `Your Five Elements are balanced — you may explore many directions, but focus on your favorable elements "${xiJi.xi}".`;

            let health = `Your Day Master is "${dayWx}", corresponding to  ${({ 'Wood': 'liver/gallbladder, eyes', 'Fire': 'heart, small intestine', 'Earth': 'spleen/stomach, muscles', 'Metal': 'lungs, large intestine', 'Water': 'kidneys, bladder' })[dayWx] || 'related systems'} — pay special attention to it.`;
            const organMap = { 'Wood': 'liver/gallbladder, eyes', 'Fire': 'heart, small intestine', 'Earth': 'spleen/stomach, muscles', 'Metal': 'lungs, large intestine', 'Water': 'kidneys, bladder' };
            if (weakCount <= 1) health += `In your BaZi, "${weak}" is weak,  corresponding to ${organMap[weak] || 'related systems'}  is prone to problems — replenish with more  ${colorMap[weak] || ''}  foods, or do  ${weak} -element exercises.`;
            if (strongCount >= 3) health += `"${strong}" is excessive,  corresponding to ${organMap[strong] || 'related systems'}  needs proper release — avoid overwork and engage more with the  ${jiList.join(', ')}  element for balance.`;

            let marriage = `Your Spouse Palace (day branch) is "${dayZhi}", belonging to the ${dayZhiWx}" element.`;
            const relation = getZhiRelation(dayGan, dayZhi);
            marriage += `The day branch and Day Master are in  ${relation}, `;
            if (relation.includes('support') || relation.includes('Harmonizing')) marriage += `Your marriage is harmonious and your spouse is a great support.`;
            else if (relation.includes('Controlling')) marriage += `In marriage, mind your communication and avoid friction from personality differences — mutual tolerance is key.`;
            else marriage += `Nurture your relationship with care — mutual understanding makes it last.`;
            if (xiList.length) marriage += `You suit a partner whose elements lean toward "${xiList.join(', ')}" for better complement and harmony.`;

            const shengMap = { 'Wood': 'Water', 'Fire': 'Wood', 'Earth': 'Fire', 'Metal': 'Earth', 'Water': 'Metal' };
            const yinXing = shengMap[dayWx] || 'Water';
            const yinCount = wuXingCount[yinXing] || 0;
            let study = `Your study luck relates to the "${yinXing}" element (Resource Star).`;
            if (yinCount >= 2) study += `You have a natural talent for learning and good memory, suited to deep study.`;
            else if (yinCount === 0) study += `Your Resource Star is weak — study harder and engage more with  ${colorMap[yinXing] || ''}  colored stationery or surroundings to boost focus.`;
            else study += `Your learning ability is moderate — persistence will bring good results.`;

            const keMap = { 'Wood': 'Earth', 'Fire': 'Metal', 'Earth': 'Water', 'Metal': 'Wood', 'Water': 'Fire' };
            const caiXing = keMap[dayWx] || 'Earth';
            const caiCount = wuXingCount[caiXing] || 0;
            let wealth = `Your Wealth Star is "${caiXing}", representing your ability to attract wealth.`;
            if (caiCount >= 2) wealth += `You are naturally lucky with money, good at managing or creating wealth, but avoid greed.`;
            else if (caiCount === 0) wealth += `Your Wealth Star is weak — rely on professional skill and connections, and lean toward  ${xiList.join(', ')} -related industries.`;
            else wealth += `Your wealth is moderate — steady investing and saving is the best strategy.`;

            return { career, health, marriage, study, wealth };
        }

        function renderZodiacCard(month, day) {
            const idx = getZodiac(month, day);
            const cnName = ZODIAC_NAMES[idx];
            const desc = ZODIAC_DESC_CN[cnName] || 'Gentle personality, full of charm.';
            const d = ZODIAC_DETAILS_CN[cnName] || { love: 'Nurture it with care and love grows sweeter.', career: 'Play to your strengths and move forward steadily.', money: 'Plan sensibly and wealth will flow in.', health: 'Maintain good lifestyle habits.', advice: 'Believe in yourself — the future is bright.' };
            return `<div class="fr-dim-head">${ZODIAC_EMOJI[idx]} ${cnName}</div><div class="fr-dim-grid">
                <div class="fr-dim-card"><h5>🧬 Personality</h5><p>${desc}</p></div>
                <div class="fr-dim-card"><h5>💕 Love</h5><p>${d.love}</p></div>
                <div class="fr-dim-card"><h5>💼 Career</h5><p>${d.career}</p></div>
                <div class="fr-dim-card"><h5>💰 Wealth</h5><p>${d.money}</p></div>
                <div class="fr-dim-card"><h5>❤️‍🩹 Health</h5><p>${d.health}</p></div>
                <div class="fr-dim-card"><h5>🌟 Advice</h5><p>${d.advice}</p></div>
            </div>`;
        }
        function renderShengxiaoCard(yearZhi) {
            const animal = ANIMALS[DI_ZHI.indexOf(yearZhi)] || 'Rat';
            const desc = ZODIAC_CHINESE_DESC[animal] || 'Gentle personality, steady fortune. ';
            const wx = WU_XING_ZHI[yearZhi] || 'Earth';
            const organMap = { 'Wood': 'liver/gallbladder', 'Fire': 'heart, small intestine', 'Earth': 'spleen/stomach', 'Metal': 'lungs, large intestine', 'Water': 'kidneys, bladder' };
            return `<div class="fr-dim-head">${ZODIAC_EMOJI_ANIMAL[animal] || '🐾'} ${animal}</div><div class="fr-dim-grid">
                <div class="fr-dim-card"><h5>🧬 Personality</h5><p>${desc}</p></div>
                <div class="fr-dim-card"><h5>💕 Love</h5><p>${animal} people are emotionally refined and loyal, best matched with a complementary partner.</p></div>
                <div class="fr-dim-card"><h5>💼 Career</h5><p>${animal} people should play to their strengths and pursue careers related to the ${animal} element.</p></div>
                <div class="fr-dim-card"><h5>💰 Wealth</h5><p>${animal} people enjoy steadily rising wealth — plan well and avoid impulse spending.</p></div>
                <div class="fr-dim-card"><h5>❤️‍🩹 Health</h5><p>Keep a regular routine and care for your ${organMap[wx] || 'liver/gallbladder'}.</p></div>
                <div class="fr-dim-card"><h5>🌟 Advice</h5><p>Uphold the fine qualities of ${animal}, adapt flexibly to change, and the future is bright.</p></div>
            </div>`;
        }
        function renderZiweiCard(dayGan) {
            const mainStar = ZIWEI_MAIN_STAR[dayGan] || 'Zi Wei';
            const s = ZIWEI_STARS[mainStar];
            if (!s) return `Life Palace Main Star: ${mainStar}`;
            return `<div class="fr-dim-head">⭐ Life Palace Main Star: ${mainStar}　<span style="font-size:12px;color:var(--text-secondary);font-weight:400;">${s.wuxing} · ${s.yinyang} · transforms into ${s.huaqi}</span></div><div class="fr-dim-grid">
                <div class="fr-dim-card" style="grid-column:1/-1;"><h5>🌟 Star Essence</h5><p><strong>Star Nature: </strong>${s.xingxing}<br><strong>Personality: </strong>${s.desc}</p></div>
                <div class="fr-dim-card"><h5>💼 Career Direction</h5><p>${s.career}</p></div>
                <div class="fr-dim-card"><h5>💕 Love Advice</h5><p>${s.love}</p></div>
                <div class="fr-dim-card" style="grid-column:1/-1;"><h5>🌟 Life Advice</h5><p>${s.advice}</p></div>
            </div>`;
        }
        function renderPlainChineseCard(dayGan, wuXingCount, pillars) {
            const t = generatePlainChineseText(dayGan, wuXingCount, pillars);
            return `<div class="fr-dim-grid">
                <div class="fr-dim-card" style="grid-column:1/-1;"><h5>💼 Career</h5><p>${t.career}</p></div>
                <div class="fr-dim-card" style="grid-column:1/-1;"><h5>❤️‍🩹 Health</h5><p>${t.health}</p></div>
                <div class="fr-dim-card" style="grid-column:1/-1;"><h5>💕 Love</h5><p>${t.marriage}</p></div>
                <div class="fr-dim-card"><h5>📚 Study</h5><p>${t.study}</p></div>
                <div class="fr-dim-card"><h5>💰 Wealth</h5><p>${t.wealth}</p></div>
            </div>`;
        }

        // ---- Life Stages / 过去现在Wei来 / 颜色佩戴Advice / Home & Office Decor Advice ----
        function generateLifeStages(dayGan, wuXingCount, pillars) {
            const dayWx = WU_XING_GAN[dayGan] || 'Earth';
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const organMap = { 'Wood': 'liver/gallbladder, eyes', 'Fire': 'heart, small intestine', 'Earth': 'spleen/stomach, muscles', 'Metal': 'lungs, large intestine', 'Water': 'kidneys, bladder' };
            const stages = [];

            const shengMap = { 'Wood': 'Water', 'Fire': 'Wood', 'Earth': 'Fire', 'Metal': 'Earth', 'Water': 'Metal' };
            const yinXing = shengMap[dayWx] || 'Water';
            const yinCount = wuXingCount[yinXing] || 0;
            let youth = `The youth period (0–20) is an important stage for laying foundations.`;
            if (yinCount >= 2) youth += `You are naturally bright with strong learning ability and easily earn teachers’ affection.`;
            else if (yinCount === 0) youth += `This stage brings study pressure — work harder and seek guidance from mentors in the  ${xiList.join(', ')}  direction; it will help greatly.`;
            else youth += `Your learning ability is moderate — stay diligent and you will achieve good results.`;
            youth += `Cultivate more interests and hobbies to build energy for the future.`;
            stages.push(youth);

            let adult = `The young-adult period (20–40) is critical for career and marriage.`;
            const keMap = { 'Wood': 'Earth', 'Fire': 'Metal', 'Earth': 'Water', 'Metal': 'Wood', 'Water': 'Fire' };
            const caiXing = keMap[dayWx] || 'Earth';
            const caiCount = wuXingCount[caiXing] || 0;
            if (caiCount >= 2) adult += `Your wealth is strong and opportunities come easily, but mind your relationships and avoid offending others through impatience.`;
            else adult += `Build your career steadily without rash moves, leveraging resources in the  ${xiList.join(', ')}  field.`;
            const dayZhi = pillars.day.zhi;
            const dayZhiWx = WU_XING_ZHI[dayZhi] || 'Earth';
            if (xiList.includes(dayZhiWx)) adult += `In love, you easily meet a suitable partner and the relationship develops smoothly.`;
            else if (jiList.includes(dayZhiWx)) adult += `In love, invest more effort and avoid conflicts from personality clashes.`;
            else adult += `In love, go with the flow, though active socializing helps.`;
            stages.push(adult);

            let mid = `Middle age (40–60) is the harvest stage of life.`;
            const selfCount = wuXingCount[dayWx] || 0;
            const total = Object.values(wuXingCount).reduce((a, b) => a + b, 0);
            const avg = total / 5;
            if (selfCount > avg * 1.3) mid += `Your Day Master is strong and energetic — suited to heavy responsibility, but balance work and rest to avoid burnout.`;
            else if (selfCount < avg * 0.7) mid += `Your Day Master is weak — focus on wellness, avoid overwork, and replenish  ${xiList.join(', ')}  energy.`;
            else mid += `Your fortune is steady — if you seize opportunities in the  ${xiList.join(', ')}  direction, your career and wealth will reach new heights.`;
            const weakestElement = Object.entries(wuXingCount).sort((a, b) => a[1] - b[1])[0]?.[0] || 'Water';
            if (wuXingCount[weakestElement] <= 1) mid += `Pay special attention to  ${organMap[weakestElement] || 'related systems'}  and get regular check-ups.`;
            stages.push(mid);

            let old = `In your senior years (after 60), rest well and cultivate inner peace.`;
            const sheng2 = { 'Wood': 'Fire', 'Fire': 'Earth', 'Earth': 'Metal', 'Metal': 'Water', 'Water': 'Wood' };
            const childXing = sheng2[dayWx] || 'Fire';
            const childCount = wuXingCount[childXing] || 0;
            if (childCount >= 2) old += `You are blessed with good children and will enjoy family bliss in your later years.`;
            else old += `Let things take their natural course with children — cultivate your own interests to enrich your later years.`;
            old += `Keep an optimistic mindset and engage more with  ${xiList.join(', ')} -element things for physical and mental well-being.`;
            stages.push(old);
            return stages;
        }
        function generateTimeDimension(tense, dayGan, wuXingCount) {
            const dayWx = WU_XING_GAN[dayGan] || 'Earth';
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const sorted = Object.entries(wuXingCount).sort((a, b) => b[1] - a[1]);
            const strong = sorted[0] ? sorted[0][0] : 'Earth',
                weak = sorted[sorted.length - 1] ? sorted[sorted.length - 1][0] : 'Water';
            const strongCount = wuXingCount[strong] || 0,
                weakCount = wuXingCount[weak] || 0;
            let text = '';
            if (tense === 'past') {
                text = `In the recent past, your life was dominated by the "${strong}" element.`;
                if (strongCount >= 3) text += `Then you were energetic, but may have missed some opportunities by being too forceful.`;
                else if (weakCount <= 1) text += `Then you may have felt inadequate, needing extra effort in many things.`;
                else text += `Overall steady, but with small storms that helped you gain experience.`;
                text += `Looking back now, those experiences became your confidence today.`;
            } else if (tense === 'present') {
                text = `You are currently in a period dominated by the "${dayWx}" element.`;
                if (xiList.includes(dayWx)) text += `This is an upward phase — take initiative and engage more with  ${xiList.join(', ')} -related people and things.`;
                else text += `This is a period to be steady and avoid rash moves, drawing on  ${xiList.join(', ')}  energy for balance.`;
                text += `Handle each present decision well — they will deeply shape your future.`;
            } else {
                text = `In the near future, your fortune will tilt toward "${xiList.join(', ')}".`;
                text += `Plan ahead in related fields — such as pursuing  ${xiList.join(', ')}  industries, or choosing the  ${xiList.join(', ')}  direction.`;
                text += `Avoid over-investing in  ${jiList.join(', ')} -related matters to conserve your energy. Stay open-minded — the future is bright.`;
            }
            return text;
        }
        const WX_COLOR_MAP = {
            'Water': { recommend: 'blue, navy, black, slate blue', avoid: 'large areas of deep yellow, earthy brown', jewelry: ['pearl necklace / studs', 'sapphire', 'aquamarine pendant', 'moonstone / white crystal'] },
            'Wood': { recommend: 'green, cyan', avoid: 'large areas of white, gold', jewelry: ['green jade / jadeite pendant', 'turquoise', 'malachite', 'peridot'] },
            'Fire': { recommend: 'red, orange, vermilion, burgundy', avoid: 'large areas of black, blue', jewelry: ['red agate', 'garnet bracelet', 'red string bracelet (with gold charm)', 'cinnabar charm'] },
            'Earth': { recommend: 'yellow, brown, beige, earth tones', avoid: 'large areas of green', jewelry: ['topaz / citrine pendant', 'amber bracelet', 'yellow agate / tiger’s eye bracelet', 'purple clay cup'] },
            'Metal': { recommend: 'white, silver, gold, light gray', avoid: 'large areas of red', jewelry: ['metal bracelet (stainless steel / titanium)', 'gold/silver necklace', 'plain band ring', 'silver jewelry'] }
        };
        // ============================================================
        //  Five Elements吉祥数字 与 手串Beads智能匹配
        //  河图Five Elements数：Water1, 6；Fire2, 7；Wood3, 8；Metal4, 9；Earth5, 10
        //  人的wrist size一般在10-30cm之间, 个位吉祥数字 (如1/3/6) 过小无法直接作为Beads, 
        //  因此在其基础上加十位 (+10/+20) , 得到落在10-30区间内的可用吉祥Beads (如11/21, 13/23, 16/26) 
        // ============================================================
        const WX_LUCKY_NUMBERS = { 'Water': [1, 6], 'Fire': [2, 7], 'Wood': [3, 8], 'Metal': [4, 9], 'Earth': [5, 10] };
        function getLuckyDigits(mainWx, secondWx) {
            const nums = [...(WX_LUCKY_NUMBERS[mainWx] || []), ...(WX_LUCKY_NUMBERS[secondWx] || [])];
            return Array.from(new Set(nums)).sort((a, b) => a - b);
        }
        function luckyDigitFamily(d) {
            if (d >= 10) return [10, 20, 30];
            return [d + 10, d + 20].filter(v => v <= 30);
        }
        function getLuckyBeadCountOptions(luckyDigits) {
            const set = new Set();
            (luckyDigits || []).forEach(d => luckyDigitFamily(d).forEach(v => set.add(v)));
            return Array.from(set).sort((a, b) => a - b);
        }
        // “Numerology”Bracelet Design的Beads目前不支持自由调整, 只能锁定为一个具体的吉祥Beads：
        // 从吉祥个位数字中, 挑选与常规16 beads手围最接近的那 (十位统一取1) , 
        // 例如幸运数字为1, 3, 5, 与6最接近的是5, 取15 beads；幸运数字为2, 7, 9, 最接近的是7, 取17 beads
        function pickTargetBeadCount(luckyDigits) {
            if (!luckyDigits || luckyDigits.length === 0) return 16;
            let best = null,
                bestDiff = 99;
            luckyDigits.forEach(d => {
                const units = d >= 10 ? 0 : d;
                const diff = Math.abs(units - 6);
                const bestUnits = best === null ? -1 : (best >= 10 ? 0 : best);
                if (diff < bestDiff || (diff === bestDiff && units > bestUnits)) {
                    bestDiff = diff;
                    best = d;
                }
            });
            const units = best >= 10 ? 0 : best;
            return 10 + units;
        }
        function renderColorAdviceCard(dayGan, wuXingCount) {
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const mainWx = xiList[0] || 'Water',
                secondWx = xiList[1] || 'Wood',
                avoidWx = jiList[0] || 'Earth';
            const mainC = WX_COLOR_MAP[mainWx] || WX_COLOR_MAP['Water'];
            const secondC = WX_COLOR_MAP[secondWx] || WX_COLOR_MAP['Wood'];
            const avoidC = WX_COLOR_MAP[avoidWx] || WX_COLOR_MAP['Earth'];
            const luckyDigits = getLuckyDigits(mainWx, secondWx);
            const luckyOptions = getLuckyBeadCountOptions(luckyDigits);
            return `<p><strong>Favorable Elements: </strong>Favorable <span class="hl">${xiList.join(', ')}</span>, Avoid ${jiList.join(', ')}</p>
                <table style="width:100%;border-collapse:collapse;font-size:13px;margin:6px 0;">
                    <thead><tr><th style="text-align:left;padding:3px 0;">Five Elements</th><th style="text-align:left;">Recommended Colors</th><th style="text-align:left;">Colors to Avoid</th></tr></thead>
                    <tbody>
                        <tr><td>${mainWx} (primary)</td><td>${mainC.recommend}</td><td>${mainC.avoid}</td></tr>
                        <tr><td>${secondWx} (secondary)</td><td>${secondC.recommend}</td><td>${secondC.avoid}</td></tr>
                        <tr><td>${avoidWx} (avoid)</td><td style="color:#c1473c;">Use sparingly</td><td>${avoidC.avoid}</td></tr>
                    </tbody>
                </table>
                <p><strong>💎 Recommended Jewelry: </strong></p>
                <ul class="fr-advice-list">
                    <li>Primary (${mainWx}): ${mainC.jewelry.join(', ')}</li>
                    <li>Secondary (${secondWx}): ${secondC.jewelry.join(', ')}</li>
                </ul>
                <p style="font-size:12px;">💡 Choose natural materials, wear them close to the skin or by your pillow, and use color as small accents.</p>
                <p><strong>🔢 Lucky Numbers: </strong>Based on your favorable elements (${mainWx}, ${secondWx}), your lucky single digits are  <span class="hl">${luckyDigits.join(', ')}</span>. Since wrists are usually 10–30cm and single digits are too few for beads, adding a tens digit keeps them lucky (e.g. with single digit ${luckyDigits.join(', ')}, the corresponding counts are  <strong>${luckyOptions.join(', ')}</strong>  beads — all optional lucky counts).</p>`;
        }
        const WX_ITEM_MAP = {
            'Water': { living: 'plants (≤1–2 pots), warm main lighting, warm-toned wall art', study: 'metal desk lamp, metal photo frame, citrine ornament', bedroom: 'small water feature (change water often), blue-gray bedding' },
            'Wood': { living: 'large plants (money tree, happy tree), wooden furniture', study: 'wooden bookshelf, asparagus fern bonsai, bamboo pen holder', bedroom: 'wooden nightstand, small potted plant' },
            'Fire': { living: 'warm main lighting, red wall art', study: 'red stationery, warm desk lamp', bedroom: 'warm desk lamp, red cushion' },
            'Earth': { living: 'ceramic vase, earth-tone rug, citrine ornament', study: 'citrine / topaz ornament, ceramic ornament, purple clay cup', bedroom: 'earth-tone bedding, ceramic ornament' },
            'Metal': { living: 'metal frame, silver decor, metal floor lamp', study: 'bronze ware, brass tray, metal storage box', bedroom: 'small metal ornament, white/gold bedding' }
        };
        function renderFengshuiItemsCard(dayGan, wuXingCount) {
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const mainWx = xiList[0] || 'Water',
                secondWx = xiList[1] || 'Wood',
                avoidWx = jiList[0] || 'Earth';
            const mainI = WX_ITEM_MAP[mainWx] || WX_ITEM_MAP['Water'];
            const secondI = WX_ITEM_MAP[secondWx] || WX_ITEM_MAP['Wood'];
            const avoidI = WX_ITEM_MAP[avoidWx] || WX_ITEM_MAP['Earth'];
            return `<p><strong>Based on your favorable elements  ${xiList.join(', ')}  — decor suggestions</strong></p>
                <table style="width:100%;border-collapse:collapse;font-size:13px;margin:6px 0;">
                    <thead><tr><th style="text-align:left;padding:3px 0;">Area</th><th style="text-align:left;">Favorable</th></tr></thead>
                    <tbody>
                        <tr><td>Entry / Living Room</td><td>${mainI.living}<br>Secondary: ${secondI.living}</td></tr>
                        <tr><td>Study / Desk</td><td>${mainI.study}<br>Secondary: ${secondI.study}</td></tr>
                        <tr><td>Bedroom / Rest Area</td><td>${mainI.bedroom}<br>Secondary: ${secondI.bedroom}</td></tr>
                    </tbody>
                </table>
                <p style="font-size:12px;">💡 Whole-home principle: primary colors should be "${mainWx}", with "${secondWx}" as secondary, and avoid "${avoidWx}" colors should be minimized.</p>`;
        }

        const ZODIAC_NAMES = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];
        const ZODIAC_EMOJI = ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓'];
        const ANIMALS = ['Rat', 'Ox', 'Tiger', 'Rabbit', 'Dragon', 'Snake', 'Horse', 'Goat', 'Monkey', 'Rooster', 'Dog', 'Pig'];

        function getZodiac(month, day) {
            const boundaries = [
                [1, 20, 10],
                [2, 19, 11],
                [3, 21, 0],
                [4, 20, 1],
                [5, 21, 2],
                [6, 21, 3],
                [7, 23, 4],
                [8, 23, 5],
                [9, 23, 6],
                [10, 23, 7],
                [11, 22, 8],
                [12, 22, 9]
            ];
            let idx = 9;
            for (const [m, d, zi] of boundaries) {
                if (month > m || (month === m && day >= d)) idx = zi;
            }
            return idx;
        }

        function getAnimal(year) { return ANIMALS[(year - 4) % 12]; }

        function getPillars(year, month, day, hourIdx) {
            function yp(y, m, d) { let yy = y; if (m < 2 || (m === 2 && d < 4)) yy = y - 1; const gi = (yy - 4) % 10,
                    zi = (yy - 4) % 12; return { gan: TIAN_GAN[(gi + 10) % 10], zhi: DI_ZHI[(zi + 12) % 12] }; }
            const y = yp(year, month, day);
            const gm = { 'Jia': 2, 'Yi': 4, 'Bing': 6, 'Ding': 8, 'Wu': 0, 'Ji': 2, 'Geng': 4, 'Xin': 6, 'Ren': 8, 'Gui': 0 };
            const SOLAR_MONTHS = [
                [1, 6, 11],
                [2, 4, 0],
                [3, 6, 1],
                [4, 5, 2],
                [5, 6, 3],
                [6, 6, 4],
                [7, 7, 5],
                [8, 8, 6],
                [9, 8, 7],
                [10, 8, 8],
                [11, 7, 9],
                [12, 7, 10]
            ];
            let k = 10;
            for (const [sm, sd, sv] of SOLAR_MONTHS) {
                if (month > sm || (month === sm && day >= sd)) k = sv;
            }
            const start = gm[y.gan] || 0;
            const mp = { gan: TIAN_GAN[(start + k) % 10], zhi: DI_ZHI[(2 + k) % 12] };
            const base = Date.UTC(2000, 0, 1);
            const target = Date.UTC(year, month - 1, day);
            const diff = Math.round((target - base) / 86400000);
            // 修复：diff 对 1999 年以前Birth Date为负数, JS 的 % 运算对负数结果也是负数, 
            // 导致 DI_ZHI[负索引] 取到 undefined, 运行到 pillars.day.zhi[0] 时直接报错崩溃
            //  (默认日期 1990-05-15 恰好触发这个问题, 这也是"Test Destiny"点击无反应的另一个原因) . 
            const mod = (n, m) => ((n % m) + m) % m;
            const dp = { gan: TIAN_GAN[mod(4 + diff, 10)], zhi: DI_ZHI[mod(6 + diff, 12)] };
            const gm2 = { 'Jia': 0, 'Yi': 2, 'Bing': 4, 'Ding': 6, 'Wu': 8, 'Ji': 0, 'Geng': 2, 'Xin': 4, 'Ren': 6, 'Gui': 8 };
            const hp = { gan: TIAN_GAN[(gm2[dp.gan] + hourIdx) % 10], zhi: DI_ZHI[(hourIdx + 12) % 12] };
            return { year: y, month: mp, day: dp, hour: hp };
        }

        function getWxCount(p) {
            const all = [
                WU_XING_GAN[p.year.gan], WU_XING_ZHI[p.year.zhi],
                WU_XING_GAN[p.month.gan], WU_XING_ZHI[p.month.zhi],
                WU_XING_GAN[p.day.gan], WU_XING_ZHI[p.day.zhi],
                WU_XING_GAN[p.hour.gan], WU_XING_ZHI[p.hour.zhi]
            ];
            const cnt = { 'Wood': 0, 'Fire': 0, 'Earth': 0, 'Metal': 0, 'Water': 0 };
            for (const w of all) { if (cnt[w] !== undefined) cnt[w]++; }
            return cnt;
        }

        // ============================================================
        //  2. Material Library (含Gold Spacer Bead, Silver Spacer Bead) 
        // ============================================================
        // Five Elementscrystal基础色系 (Wood绿 · Fire红 · Earth黄 · Metal白 · Water蓝) , 
        // Main Stone/Secondary/Wealth Bead/Love Bead/Health Bead/Study贵人 统一使用同一套素材, 仅size/价格分级不同
        const WX_CRYSTAL_TYPES = [
            { name: 'Green Wood Crystal', color: '#4caf50', wx: 'Wood' },
            { name: 'Red Fire Crystal', color: '#e64a3b', wx: 'Fire' },
            { name: 'Yellow Earth Crystal', color: '#f0b840', wx: 'Earth' },
            { name: 'White Metal Crystal', color: '#f2ede0', wx: 'Metal' },
            { name: 'Blue Water Crystal', color: '#2f9fe0', wx: 'Water' }
        ];
        const WX_SIZE_PRICE = [
            { size: '8cm', price: 6 },
            { size: '10cm', price: 8 },
            { size: '12cm', price: 10 }
        ];
        function buildWxCrystalItems() {
            const items = [];
            WX_CRYSTAL_TYPES.forEach(t => {
                WX_SIZE_PRICE.forEach(s => {
                    items.push({ name: `${t.name} ${s.size}`, color: t.color, price: s.price, tag: s.size, wx: t.wx, size: s.size, currency: '$' });
                });
            });
            return items;
        }
        const WX_CRYSTAL_ITEMS = buildWxCrystalItems();
        const SPACER_ITEMS = [
            { name: 'Gold Spacer Bead', color: '#d4af37', price: 20, tag: 'gold', wx: 'Metal', size: 'metal', currency: '$' },
            { name: 'Silver Spacer Bead', color: '#c0c0c0', price: 10, tag: 'silver', wx: 'Metal', size: 'metal', currency: '$' }
        ];

        // real-shot crystal/隔珠图片映射 ( corresponding to :root 里内嵌的 base64 图) 
        const WX_BEAD_IMG_VAR = {
            'Wood': 'var(--crystal-wood-img)',
            'Fire': 'var(--crystal-fire-img)',
            'Earth': 'var(--crystal-earth-img)',
            'Metal': 'var(--crystal-metal-img)',
            'Water': 'var(--crystal-water-img)'
        };
        function getBeadImgVar(bead) {
            if (bead.role === 'spacer' || bead.size === 'metal') {
                return (bead.name || '').includes('Silver') ? 'var(--spacer-silver-img)' : 'var(--spacer-gold-img)';
            }
            return WX_BEAD_IMG_VAR[bead.wx] || WX_BEAD_IMG_VAR['Earth'];
        }
        // 按真实 size等比例缩放bead直径：8cm/10cm/12cm  corresponding to固定像素, 隔珠始终明显更小
        const BEAD_PX_BY_SIZE = { '8cm': 22, '10cm': 27, '12cm': 33 };
        function beadPxSize(bead, scale) {
            scale = scale || 1;
            if (bead.role === 'spacer' || bead.size === 'metal') return Math.round(15 * scale);
            return Math.round((BEAD_PX_BY_SIZE[bead.size] || 27) * scale);
        }

        // 收拢成串：bead严格贴合珠盘本身的椭圆形状摆放 (珠盘是什么角度, 手链就是什么角度) , 
        // 圆心与珠盘圆心完全重合, 不会悬浮或偏移；each bead仍是独立的正圆图片, 不会被压扁拉伸, 
        // 只是排列的路径跟随珠盘的椭圆——这样bead始终"贴"在珠盘里, 不会露出盘外或浮在空中. 
        // 同时按each bead的真实直径分配弧长, 让相邻bead边缘紧贴 (弹力线串珠不会留大缝隙) . 
        function computeRingLayout(beads, cx, cy, scale, maxRx, maxRy) {
            scale = scale || 1;
            if (maxRy === undefined) maxRy = maxRx; // 兼容旧调用 (正圆) 
            const sizes = beads.map(b => beadPxSize(b, scale));
            const circumference = sizes.reduce((s, d) => s + d, 0);
            const naturalRadius = circumference / (2 * Math.PI);
            const ratio = (maxRx && maxRy) ? maxRx / maxRy : 1;
            // 保持椭圆长短轴比例与珠盘一致, 同时面积近似等于按周长算出的正圆面积
            let ry = naturalRadius / Math.sqrt(ratio);
            let rx = ry * ratio;
            let sizeScale = 1;
            if (maxRx && maxRy && (rx > maxRx || ry > maxRy)) {
                const shrink = Math.min(maxRx / rx, maxRy / ry);
                rx *= shrink;
                ry *= shrink;
                sizeScale = shrink;
            }
            // 椭圆周长近似 (Ramanujan 公式) , 用于把each bead的弧长换算成角度增量
            const hRatio = Math.pow(rx - ry, 2) / Math.pow(rx + ry, 2);
            const perimeter = Math.PI * (rx + ry) * (1 + (3 * hRatio) / (10 + Math.sqrt(4 - 3 * hRatio)));
            const positions = [];
            let angle = -Math.PI / 2;
            for (let i = 0; i < beads.length; i++) {
                const d = sizes[i] * sizeScale;
                const angStep = perimeter > 0 ? (d / perimeter) * 2 * Math.PI : 0;
                const centerAngle = angle + angStep / 2;
                positions.push({
                    x: cx + rx * Math.cos(centerAngle),
                    y: cy + ry * Math.sin(centerAngle),
                    size: d
                });
                angle += angStep;
            }
            return { positions, rx, ry };
        }

        const MATERIALS = {
            all: WX_CRYSTAL_ITEMS.concat(SPACER_ITEMS),
            main: WX_CRYSTAL_ITEMS,
            second: WX_CRYSTAL_ITEMS,
            wealth: WX_CRYSTAL_ITEMS,
            marriage: WX_CRYSTAL_ITEMS,
            health: WX_CRYSTAL_ITEMS,
            study: WX_CRYSTAL_ITEMS,
            spacer: SPACER_ITEMS
        };

    // ============================================================
    //  产品分类与发财树摆件（固定产品，无动效 DIY）
    //  发财树 5 色对应五行，$89/个，命理手作里按五行喜用神智能配色推荐
    // ============================================================
    // 发财树编号前缀 bjfcs（baijian facaishu 拼音缩写），红色起排第一
    // 6 款：红/绿(深)/绿松石/黄/紫白(白)/蓝；绿系 2 款都归 Wood，紫白归白(Metal)
    const MONEY_TREE_TYPES = [
        { name: 'Red Money Tree',    color: '#e64a3b', wx: 'Fire',  price: 89, sku: 'bjfcs0000001', img: 'money-tree-red.png' },
        { name: 'Green Money Tree',   color: '#4caf50', wx: 'Wood',  price: 89, sku: 'bjfcs0000002', img: 'money-tree-green.png' },
        { name: 'Teal Money Tree',    color: '#1abc9c', wx: 'Wood',  price: 89, sku: 'bjfcs0000003', img: 'money-tree-teal.png' },
        { name: 'Yellow Money Tree',  color: '#f0b840', wx: 'Earth', price: 89, sku: 'bjfcs0000004', img: 'money-tree-yellow.png' },
        { name: 'White Money Tree',   color: '#c9b8d8', wx: 'Metal', price: 89, sku: 'bjfcs0000005', img: 'money-tree-white.png' },
        { name: 'Blue Money Tree',    color: '#2f9fe0', wx: 'Water', price: 89, sku: 'bjfcs0000006', img: 'money-tree-blue.png' }
    ];
    const WX_TO_TREE = { 'Wood': 'Green Money Tree', 'Fire': 'Red Money Tree', 'Earth': 'Yellow Money Tree', 'Metal': 'White Money Tree', 'Water': 'Blue Money Tree' };
    // Wood 还可推 Teal（绿松石），同五行两种绿色
    const WX_TO_TREES = { 'Wood': ['Green Money Tree', 'Teal Money Tree'], 'Fire': ['Red Money Tree'], 'Earth': ['Yellow Money Tree'], 'Metal': ['White Money Tree'], 'Water': ['Blue Money Tree'] };
    // 产品分类（数据驱动，方便以后加 SKU）：inDiy=false 表示无动效 DIY，不出现在 DIY 页
    const PRODUCT_CATEGORIES = [
        { id: 'all', name: 'All Recommended', inDiy: true },
        { id: 'bracelet', name: 'Crystal Bracelet', inDiy: true },
        { id: 'ornament', name: 'Ornament', inDiy: false }
    ];
    let activeProductCat = 'all';

    // ---- 发财树摆件：命理推荐 + 介绍 + 加购物车 ----
    function recommendMoneyTrees() {
        const xiList = appState.xiList || [];
        // Wood 喜用神推 2 款绿（深绿+绿松石），其他五行各 1 款
        const trees = [];
        xiList.forEach(wx => {
            const list = WX_TO_TREES[wx];
            if (list) list.forEach(t => { if (trees.indexOf(t) < 0) trees.push(t); });
        });
        return trees.length > 0 ? trees : ['Green Money Tree', 'Teal Money Tree'];
    }
    function buildMoneyTreeIntro(name) {
        const tree = MONEY_TREE_TYPES.find(t => t.name === name);
        if (!tree) return '';
        const xiList = appState.xiList || [];
        const dayWx = WU_XING_GAN[appState.lastDayGan] || 'Earth';
        const wxDesc = {
            Wood: 'growth, vitality and upward momentum',
            Fire: 'passion, drive and flourishing fortune',
            Earth: 'stability, nourishment and grounded wealth',
            Metal: 'clarity, discipline and accumulated riches',
            Water: 'flow, wisdom and endless abundance'
        };
        const desc = wxDesc[tree.wx] || 'positive energy';
        return 'Matched to your favorable element' + (xiList.length > 1 ? 's ' : ' ') + xiList.join(' & ') + ' (Day Master ' + appState.lastDayGan + ' · ' + dayWx + '), this ' + tree.name + ' channels ' + desc + ' — an auspicious ornament for desk or home to attract wealth and harmony.';
    }
    function addMoneyTreeToCart(name) {
        if (!appState.hasTested) { showToast('Please run your destiny test first'); return; }
        const tree = MONEY_TREE_TYPES.find(t => t.name === name);
        if (!tree) return;
        appState.cart.push({
            name: 'Money Tree Ornament (Numerology Direct Order)',
            spec: tree.name + ' · ' + tree.wx + ' element · Numerology matched',
            price: tree.price,
            qty: 1,
            sku: tree.sku,
            source: 'money_tree',
            wristSize: '',
            beadsSnapshot: [],
            moneyTreeColor: tree.name,
            mingliSummary: buildMoneyTreeIntro(tree.name)
        });
        updateCartUI();
        showToast('✅ Added: ' + tree.name + ' · $' + tree.price);
    }
    // ---- 产品推荐区（命理手作页）卡片：图在上，名称+价格+销量+加购在下；点击进详情弹窗 ----
    // 手链价格根据命理智能匹配的 beads 实际计算（不写死 $8）
    function calcBraceletPrice() {
        const beads = appState.beads || [];
        const total = beads.reduce((s, b) => s + (b.price || 0), 0);
        return total > 0 ? total : 0;
    }
    function renderProductCardBracelet() {
        const price = calcBraceletPrice();
        const priceStr = price > 0 ? ('$' + price.toFixed(2)) : 'Customize';
        const sub = price > 0 ? '' : '<div class="product-card-sold" style="margin-top:2px;">✨ Auto-matched to your chart</div>';
        // 加购按钮统一为 "Add to Cart"（价格单独显示在上方，不再叠在按钮里；3 个产品加购按钮对齐）
        return `<div class="product-card" onclick="showProductDetail('bracelet')"><div class="product-card-img product-card-img-bracelet">${renderBraceletSnapshot()}</div><div class="product-card-info"><div class="product-card-title">💎 Crystal Bracelet</div><div class="product-card-price">${priceStr} <span class="product-card-sold">⭐ 12,847 sold</span>${sub}</div></div><div class="product-card-actions" onclick="event.stopPropagation()"><button class="btn-save-cart cart" onclick="addDiyCart('numerology')">🛒 Add to Cart</button></div></div>`;
    }
    function renderProductCardMoneyTree() {
        // 只显示命理喜用神智能匹配的发财树（Wood 喜用神推 2 款绿），用实拍图
        const recommended = recommendMoneyTrees();
        const imgMap = (typeof window !== 'undefined' && window._mtImg) ? window._mtImg : {};
        return recommended.map(name => {
            const tree = MONEY_TREE_TYPES.find(t => t.name === name);
            if (!tree) return '';
            const imgUrl = imgMap[tree.name] || imgMap[name] || '';
            const imgHtml = imgUrl ? `<img src="${imgUrl}" alt="${tree.name}" loading="lazy" />` : `<div class="money-tree-visual" style="--tree-color:${tree.color};"></div>`;
            // 加购按钮统一为 "Add to Cart"（价格单独显示在上方，不再叠在按钮里）
            return `<div class="product-card" onclick="showProductDetail('money_tree', '${tree.name}')"><div class="product-card-img product-card-img-tree">${imgHtml}</div><div class="product-card-info"><div class="product-card-title">🌳 ${tree.name}</div><div class="product-card-price">$${tree.price} <span class="product-card-sold">⭐ 10,523 sold</span></div></div><div class="product-card-actions" onclick="event.stopPropagation()"><button class="btn-save-cart cart" onclick="addMoneyTreeToCart('${tree.name}')">🛒 Add to Cart</button></div></div>`;
        }).join('');
    }
    // ---- 产品详情弹窗（点击卡片进入）----
    function showProductDetail(type, key) {
        let html = '';
        if (type === 'bracelet') {
            const price = calcBraceletPrice();
            const priceStr = price > 0 ? ('$' + price.toFixed(2)) : 'Customize in DIY Studio';
            const beadsCount = (appState.beads || []).length;
            const beadInfo = beadsCount > 0 ? `<p style="margin-top:10px;font-size:13px;color:var(--text-secondary);">⭐ 12,847 sold · ${beadsCount} hand-picked beads tailored to your favorable elements · Base $8 per 10cm crystal + $20 gold spacer · Customizable in DIY Studio</p>` : `<p style="margin-top:10px;font-size:13px;color:var(--text-secondary);">⭐ 12,847 sold · Base $8 per 10cm crystal + $20 gold spacer · Customizable in DIY Studio</p>`;
            html = `<div class="modal-box" onclick="event.stopPropagation()"><h3>💎 Crystal Bracelet</h3><div class="product-detail-body">${renderBraceletSnapshot()}</div><p style="margin-top:14px;line-height:1.65;font-size:14px;">A Five-Elements auto-generated bracelet tailored to your birth chart's favorable elements. Each crystal and color is carefully matched to attract wealth, improve health, and balance the energy of your Day Master <strong>${appState.lastDayGan || ''}</strong> (favorable: <strong>${(appState.xiList || []).join(' & ')}</strong>). Ideal for daily wear, gifting, or a personal talisman.</p><p style="margin-top:8px;font-size:15px;font-weight:700;color:var(--primary);">Total: ${priceStr}</p>${beadInfo}<div class="modal-actions"><button class="btn-save-cart cart" onclick="addDiyCart('numerology'); closeProductDetail();">🛒 Add to Cart · ${priceStr}</button><button class="btn-save-cart save" onclick="navigateTo('master'); closeProductDetail();">🎨 Customize in DIY Studio</button><button class="btn-edit" onclick="closeProductDetail()">Close</button></div></div>`;
        } else if (type === 'money_tree') {
            const tree = MONEY_TREE_TYPES.find(t => t.name === key);
            if (!tree) return;
            const imgMap = (typeof window !== 'undefined' && window._mtImg) ? window._mtImg : {};
            const treeImgUrl = imgMap[tree.name] || imgMap[tree.name.trim()] || '';
            const treeImg = treeImgUrl ? `<img src="${treeImgUrl}" alt="${tree.name}" style="width:100%;border-radius:var(--radius-sm);max-height:240px;object-fit:contain;background:var(--bg);" />` : `<div class="money-tree-visual" style="--tree-color:${tree.color};height:200px;"></div>`;
            html = `<div class="modal-box" onclick="event.stopPropagation()"><h3>🌳 ${tree.name}</h3><div style="margin:12px 0;">${treeImg}</div><p style="margin-top:8px;line-height:1.65;font-size:14px;">${buildMoneyTreeIntro(tree.name)}</p><p style="margin-top:10px;font-size:13px;color:var(--text-secondary);">Element: ${tree.wx} · ⭐ 10,523 sold · SKU: ${tree.sku}</p><div class="modal-actions"><button class="btn-save-cart cart" onclick="addMoneyTreeToCart('${tree.name}'); closeProductDetail();">🛒 Add to Cart</button><button class="btn-edit" onclick="closeProductDetail()">Close</button></div></div>`;
        }
        const overlay = document.getElementById('productDetailOverlay');
        if (overlay) { overlay.innerHTML = html; overlay.classList.add('open'); }
    }
    function closeProductDetail() {
        const overlay = document.getElementById('productDetailOverlay');
        if (overlay) overlay.classList.remove('open');
    }
    function renderRecommendedProducts(cat) {
        const showBracelet = (cat === 'all' || cat === 'bracelet');
        const showOrnament = (cat === 'all' || cat === 'ornament');
        let cards = '';
        if (showBracelet) cards += renderProductCardBracelet();
        if (showOrnament) cards += renderProductCardMoneyTree();
        return '<div class="product-grid">' + cards + '</div>';
    }
    function switchProductCat(cat) {
        activeProductCat = cat;
        document.querySelectorAll('.product-cat-tab').forEach(el => el.classList.toggle('active', el.dataset.pcat === cat));
        const grid = document.getElementById('productGrid');
        if (grid) grid.innerHTML = renderRecommendedProducts(cat);
    }
    // ---- 报告解锁：默认 520 密码，付费 $1（addReportToCart）后邮件收 PDF ----
    function unlockReport() {
        const pwd = document.getElementById('reportUnlockPwd');
        if (pwd && pwd.value === '520') {
            const wrap = document.getElementById('reportLockedWrap');
            if (wrap) wrap.classList.add('unlocked');
            try { localStorage.setItem('reportUnlocked', '1'); } catch (e) {}
            showToast('✅ Full report unlocked');
        } else {
            showToast('❌ Wrong password');
        }
    }

        // ============================================================
        //  3. 应用状态
        // ============================================================
        let appState = {
            cart: [],
            beads: [],
            activeCat: 'main',
            isCollapsed: false,
            plateStyle: 'wood',
            lastPillars: null,
            lastWxCount: null,
            lastDayGan: 'Jia',
            xiList: ['Wood', 'Fire'],
            jiList: ['Metal', 'Earth'],
            hasTested: false,
            luckyDigits: [],
            targetBeadCount: 18,
            profile: { name: 'Star User', email: 'user@example.com', avatar: '🧑' },
            physicsRunning: false,
            animating: false
        };

        // ============================================================
        //  4. 导航
        // ============================================================
        function navigateTo(page) {
            document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
            document.getElementById('page-' + page).classList.add('active');
            document.querySelectorAll('.nav-tabs .tab-item').forEach(t => t.classList.remove('active'));
            const tab = document.querySelector(`.nav-tabs .tab-item[data-tab="${page}"]`);
            if (tab) tab.classList.add('active');
            document.getElementById('cartOverlay').classList.remove('open');
            if (page === 'master') {
                renderMaterials();
                if (!appState.hasTested && appState.beads.length === 0) {
                    generateRandomBeads(18);
                } else {
                    renderBeads();
                    if (appState.beads.length > 0 && !appState.animating) {
                        setTimeout(() => startFallAnimation(), 400);
                    }
                }
                updateWxExplanation();
            }
            if (page === 'diy') {
                if (appState.lastPillars) renderFinalReport(appState.lastPillars, appState.lastWxCount, appState.lastDayGan);
            }
            // SPA 路由：把当前页面写到 URL hash，浏览器 back/forward 可在页面间切换（不离开独立站）
            // 用 pushState（每次切页加 history 条目）让 back 能回到上一页；重复点同一页用 replaceState 避免栈污染
            try {
                const _cur = (location.hash || '').replace('#','');
                if (_cur === page) { history.replaceState({ page: page }, '', '#' + page); }
                else { history.pushState({ page: page }, '', '#' + page); }
            } catch (e) {}
        }
        // 浏览器 back/forward：监听 popstate 恢复 hash 对应页面（不调用 pushState，避免循环）
        window.addEventListener('popstate', function(ev){
            const _p = (location.hash || '#home').replace('#','') || 'home';
            if (document.getElementById('page-' + _p)) {
                document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
                document.getElementById('page-' + _p).classList.add('active');
                document.querySelectorAll('.nav-tabs .tab-item').forEach(t => t.classList.remove('active'));
                const _t = document.querySelector('.nav-tabs .tab-item[data-tab="' + _p + '"]');
                if (_t) _t.classList.add('active');
            }
        });
        // 首次加载：如果 URL 有 hash，恢复对应页面
        (function(){
            const _h = (location.hash || '').replace('#','');
            if (_h && document.getElementById('page-' + _h)) {
                document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
                document.getElementById('page-' + _h).classList.add('active');
                document.querySelectorAll('.nav-tabs .tab-item').forEach(t => t.classList.remove('active'));
                const _t = document.querySelector('.nav-tabs .tab-item[data-tab="' + _h + '"]');
                if (_t) _t.classList.add('active');
            }
        })();

        // ============================================================
        //  5. Cart
        // ============================================================
        function updateCartUI() {
            const badge = document.getElementById('cartBadge');
            const dot = document.getElementById('navCartDot');
            const total = appState.cart.reduce((s, i) => s + i.qty, 0);
            badge.textContent = total;
            if (total > 0) { dot.classList.add('show'); } else { dot.classList.remove('show'); }
            renderCartPanel();
        }

        function renderCartPanel() {
            const container = document.getElementById('cartItems');
            const footer = document.getElementById('cartFooter');
            if (appState.cart.length === 0) {
                container.innerHTML =
                    `<div class="cart-empty"><span class="big">🛍️</span>Your cart is empty<br><span style="font-size:14px;">Design your own energy bracelet</span></div>`;
                footer.style.display = 'none';
                return;
            }
            let html = '';
            let totalPrice = 0;
            appState.cart.forEach((item, idx) => {
                const price = item.price || 0;
                const subtotal = price * item.qty;
                totalPrice += subtotal;
                html += `
                    <div class="cart-item">
                        <div class="item-info">
                            <div class="name">${item.name}</div>
                            <div class="spec">${item.spec || ''}</div>
                            <div class="sku">SKU: ${item.sku || '--'}</div>
                            <div class="price">$${price}</div>
                        </div>
                        <div class="item-qty">
                            <button onclick="updateQty(${idx}, -1)">−</button>
                            <span class="qty">${item.qty}</span>
                            <button onclick="updateQty(${idx}, 1)">+</button>
                        </div>
                        <button class="remove-btn" onclick="removeFromCart(${idx})">✕</button>
                    </div>
                `;
            });
            container.innerHTML = html;
            document.getElementById('cartTotal').textContent = '$' + totalPrice;
            footer.style.display = '';
        }

        function toggleCart() {
            const overlay = document.getElementById('cartOverlay');
            overlay.classList.toggle('open');
            if (overlay.classList.contains('open')) renderCartPanel();
        }

        // 商品SKU: 每次Add to Cart都生成一个唯一编号, 避免同名商品无法区分
        let _skuCounter = 0;
        function generateProductCode() {
            _skuCounter++;
            const ts = Date.now().toString(36).toUpperCase();
            const rand = Math.random().toString(36).slice(2, 6).toUpperCase();
            return `SR-${ts}-${rand}${_skuCounter}`;
        }

        function addToCart(name, spec, price, qty = 1) {
            // 每件商品都是独立的定制作品, 即便名称相同也不合并数量, 各自生成商品编号
            appState.cart.push({ name, spec, price, qty, sku: generateProductCode() });
            updateCartUI();
            showToast(`✅ Added: ${name}`);
        }

                function addDiyCart(source) {
            if (appState.beads.length === 0) { showToast('Please add beads first'); return; }
            const totalPrice = appState.beads.reduce((s, b) => s + (b.price || 0), 0);
            const isNumerology = source === 'numerology';
            const label = isNumerology ? 'Numerology Order' : 'DIY Studio';
            const wristSize = document.getElementById('wristSize').value;
            const spec = `${label} · ${appState.beads.length} beads · Wrist ${wristSize}cm`;
            const beadsSnapshot = appState.beads.map(b => ({ name: b.name, wx: b.wx, size: b.size, role: b.role }));
            appState.cart.push({
                name: `Fortune Stone Bracelet (${label}) `,
                spec,
                price: totalPrice,
                qty: 1,
                sku: generateProductCode(),
                source,
                wristSize,
                beadsSnapshot,
                mingliSummary: (typeof buildCompositionSummaryText === 'function') ? buildCompositionSummaryText() : ''
            });
            updateCartUI();
            showToast(`✅ Added: Fortune Stone Bracelet (${label}) `);
        }

        // ---- 命理报告下单 ($1，PDF 前端生成 + Shopify 自动发订单邮件给客户) ----
        function addReportToCart() {
            if (!appState.hasTested) { showToast('Please run your destiny test first'); return; }
            const dateStr = document.getElementById('energyBirthDate').value || '';
            const hourIdx = parseInt(document.getElementById('energyBirthHour').value || '0');
            const reportText = buildFullReportText(appState.lastPillars, appState.lastWxCount, appState.lastDayGan, appState.xiList, appState.jiList);
            appState.cart.push({
                name: 'Numerology Report (PDF)',
                spec: `Personal Destiny Report · ${dateStr}`,
                price: 1,
                qty: 1,
                sku: 'RPT-' + generateProductCode(),
                source: 'report',
                wristSize: '',
                beadsSnapshot: [],
                mingliSummary: reportText,
                reportData: {
                    birthDate: dateStr,
                    hourIdx,
                    dayGan: appState.lastDayGan,
                    xiList: appState.xiList,
                    jiList: appState.jiList,
                    pillars: appState.lastPillars,
                    wxCount: appState.lastWxCount,
                    fullText: reportText
                }
            });
            updateCartUI();
            showToast('✅ Added: Numerology Report · $1');
        }

        function buildFullReportText(pillars, wxCount, dayGan, xiList, jiList) {
            const dayWx = (window.WU_XING_GAN && pillars && pillars.day && window.WU_XING_GAN[pillars.day.gan]) || 'Wood';
            const lines = [];
            lines.push(`Day Master: ${pillars.day.gan} (${dayWx})`);
            lines.push(`Year Pillar: ${pillars.year.gan}${pillars.year.zhi}`);
            lines.push(`Month Pillar: ${pillars.month.gan}${pillars.month.zhi}`);
            lines.push(`Day Pillar: ${pillars.day.gan}${pillars.day.zhi}`);
            lines.push(`Hour Pillar: ${pillars.hour.gan}${pillars.hour.zhi}`);
            lines.push(`Favorable Elements: ${xiList.join(', ')}`);
            lines.push(`Avoid Elements: ${jiList.join(', ')}`);
            try {
                const r = document.getElementById('finalReportSections');
                if (r) lines.push(r.innerText.replace(/\s+/g, ' ').slice(0, 3000));
            } catch (e) {}
            return lines.join('\n');
        }

        // ---- 邮箱查询订单 ----
        async function trackOrdersByEmail() {
            const email = (document.getElementById('orderTrackEmail').value || '').trim();
            const out = document.getElementById('orderTrackResult');
            if (!email || !email.includes('@')) { out.innerHTML = '<span style="color:#c1473c;">Please enter a valid email.</span>'; return; }
            out.innerHTML = '<span style="color:var(--text-secondary);">Looking up...</span>';
            try {
                const url = (window.CAIYUNSHI_BACKEND_URL || '').replace(/\/+$/, '') + '/api/orders-by-email';
                const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
                const data = await r.json();
                if (!data.orders || data.orders.length === 0) {
                    out.innerHTML = '<span style="color:var(--text-secondary);">No orders found for this email yet.</span>';
                    return;
                }
                const statusLabel = { paid: 'Paid', pending: 'Pending Payment', fulfilled: 'Shipped', partially_paid: 'Partially Paid', refunded: 'Refunded', cancelled: 'Cancelled' };
                const items = data.orders.map(o => {
                    const status = (o.displayFinancialStatus || 'pending').toLowerCase();
                    const cls = status === 'paid' || status === 'fulfilled' ? 'shipped' : status === 'refunded' ? 'done' : 'pending';
                    const date = o.createdAt ? o.createdAt.slice(0, 10) : '';
                    const link = o.orderStatusUrl || ('https://' + (window.location.hostname || '') + '/account/orders/' + (o.id || ''));
                    return `<div class="order-item"><span><span class="order-id">Order #${o.orderNumber || o.name || o.id}</span><br><span class="order-date">${date}</span></span><span class="order-status ${cls}">${statusLabel[status] || status}</span><a href="${link}" target="_blank" rel="noopener" style="margin-left:8px;font-size:12px;color:var(--gold);">View</a></div>`;
                }).join('');
                out.innerHTML = items;
            } catch (e) {
                out.innerHTML = '<span style="color:#c1473c;">Lookup failed, please try again later.</span>';
                console.error(e);
            }
        }

        function updateQty(idx, delta) {
            if (appState.cart[idx]) {
                appState.cart[idx].qty = Math.max(1, appState.cart[idx].qty + delta);
                updateCartUI();
            }
        }

        function removeFromCart(idx) {
            appState.cart.splice(idx, 1);
            updateCartUI();
            if (appState.cart.length === 0) document.getElementById('cartOverlay').classList.remove('open');
        }

                const ORDER_BACKEND_URL = window.CAIYUNSHI_BACKEND_URL && window.CAIYUNSHI_BACKEND_URL.indexOf('YOUR-SUBDOMAIN') === -1
            ? window.CAIYUNSHI_BACKEND_URL
            : 'https://caiyun-shi-order-backend.jewellabx.workers.dev';

        async function checkout() {
            if (appState.cart.length === 0) { showToast('Your cart is empty'); return; }
            const missing = appState.cart.find(it => it.source !== 'report' && it.source !== 'money_tree' && (!it.beadsSnapshot || it.beadsSnapshot.length === 0));
            if (missing) { showToast('Some cart items are missing bead details and cannot be checked out'); return; }
            showToast('💳 Generating your order...');
            // 对命理报告商品，先用 jsPDF 生成 PDF base64，随订单一起上传
            for (const it of appState.cart) {
                if (it.source === 'report') {
                    try { it.pdfBase64 = await generateReportPdfBase64(it.reportData); }
                    catch (e) { console.error('PDF generation failed', e); }
                }
            }
            const items = appState.cart.map(it => ({
                beads: it.beadsSnapshot,
                qty: it.qty,
                wristSize: it.wristSize,
                source: it.source,
                mingliSummary: it.mingliSummary,
                reportData: it.reportData || undefined,
                pdfBase64: it.pdfBase64 || undefined,
                moneyTreeColor: it.moneyTreeColor || undefined
            }));
            try {
                const res = await fetch(`${ORDER_BACKEND_URL}/api/create-order`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });
                const data = await res.json();
                if (!res.ok) { showToast('❌ ' + (data.error || 'Order failed, please try again later')); return; }
                window.location.href = data.invoiceUrl;
            } catch (err) {
                console.error(err);
                showToast('❌ Network error, please try again later');
            }
        }

        // 用 jsPDF 生成命理报告 PDF，返回纯 base64（不含 data: 前缀）；jsPDF 未加载时返回 null
        async function generateReportPdfBase64(reportData) {
            if (typeof window.jspdf === 'undefined' || !window.jspdf.jsPDF) return null;
            const { jsPDF } = window.jspdf;
            const doc = new jsPDF({ unit: 'mm', format: 'a4' });
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(20);
            doc.text('Numerology Report', 105, 20, { align: 'center' });
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(10);
            doc.text('Fortune Stone · Star Energy', 105, 27, { align: 'center' });
            doc.setDrawColor(180);
            doc.line(20, 32, 190, 32);
            const rd = reportData || {};
            const lines = [];
            if (rd.birthDate) lines.push('Birth Date: ' + rd.birthDate);
            if (rd.dayGan) lines.push('Day Master: ' + rd.dayGan);
            if (rd.xiList && rd.xiList.length) lines.push('Favorable Elements: ' + rd.xiList.join(', '));
            if (rd.jiList && rd.jiList.length) lines.push('Avoid Elements: ' + rd.jiList.join(', '));
            if (rd.fullText) lines.push('');
            if (rd.fullText) lines.push(rd.fullText);
            const body = doc.splitTextToSize(lines.join('\n'), 170);
            doc.setFontSize(11);
            doc.text(body, 20, 42);
            const dataUri = doc.output('datauristring');
            const comma = dataUri.indexOf(',');
            return comma >= 0 ? dataUri.slice(comma + 1) : dataUri;
        }

        // ============================================================
        //  6. Toast & 音效
        // ============================================================
        let toastTimer = null;

        function showToast(msg) {
            const el = document.getElementById('toast');
            el.textContent = msg;
            el.classList.add('show');
            clearTimeout(toastTimer);
            toastTimer = setTimeout(() => el.classList.remove('show'), 2200);
        }

        let audioCtx = null;

        function playTone(freq, dur, type = 'sine', vol = 0.12) {
            try {
                if (!audioCtx) audioCtx = new(window.AudioContext || window.webkitAudioContext)();
                const osc = audioCtx.createOscillator();
                const gain = audioCtx.createGain();
                osc.type = type;
                osc.frequency.value = freq;
                gain.gain.value = vol;
                gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + dur);
                osc.connect(gain);
                gain.connect(audioCtx.destination);
                osc.start();
                osc.stop(audioCtx.currentTime + dur);
            } catch (e) {}
        }

        function soundAdd() { playTone(800, 0.12);
            setTimeout(() => playTone(1000, 0.1), 80); }

        function soundRemove() { playTone(500, 0.15, 'sawtooth', 0.08); }

        function soundCollapse() { playTone(600, 0.1);
            setTimeout(() => playTone(800, 0.1), 100);
            setTimeout(() => playTone(1000, 0.12), 200); }

        function soundScatter() { playTone(400, 0.15);
            setTimeout(() => playTone(300, 0.15), 120); }

        function soundInspire() { playTone(700, 0.1);
            setTimeout(() => playTone(900, 0.1), 100);
            setTimeout(() => playTone(1100, 0.12), 200);
            setTimeout(() => playTone(1300, 0.15), 300); }

        function soundBounce(style) {
            playImpactSound(style, 0.5);
        }

        // 合成撞击音效：用噪声脉冲 + 带通滤波模拟不同材质的音色, 参数是参考了crystal beadZi
        // 落在Wood盘/Gold盘/Dark盘上的实际音频, 分析了撞击瞬间的频谱峰值后调出来的：
        // Wood = 低频 (约230Hz) 闷响打底, 另外叠加一层Wood头空腔特有的中频"哒嗒"共振
        //         (约520Hz带通, 衰减很快) , 这是Wood区别于其他材质最明显的音色特征；
        // Gold = 明显偏高频 (3700～5000Hz) 的清脆"叮"声, metal回响拖得比较长；
        // Dark = 低频闷响 (约150Hz) 为主, 比Wood更闷更沉, 几乎没有中频共振, 
        //        只带一点点被哑光材质吸得很闷的高频哒声, 和Wood的清亮"哒嗒"声区分开
        function playImpactSound(style, intensity) {
            try {
                if (!audioCtx) audioCtx = new(window.AudioContext || window.webkitAudioContext)();
                const now = audioCtx.currentTime;
                intensity = Math.max(0.15, Math.min(1, intensity || 0.5));

                const profiles = {
                    wood: { freq: 240, q: 1.2, decay: 0.08, type: 'lowpass', vol: 0.15, ring: false,
                        tick: true, tickFreq: 2600, tickVol: 0.04, tickDecay: 0.03,
                        knock: true, knockFreq: 520, knockQ: 2.4, knockDecay: 0.06, knockVol: 0.1 },
                    stone: { freq: 1900, q: 3.5, decay: 0.06, type: 'bandpass', vol: 0.12, ring: true, ringFreq: 2600 },
                    gold: { freq: 4200, q: 5, decay: 0.24, type: 'bandpass', vol: 0.11, ring: true, ringFreq: 4800,
                        tick: false },
                    dark: { freq: 140, q: 1, decay: 0.18, type: 'lowpass', vol: 0.15, ring: false,
                        tick: true, tickFreq: 2100, tickVol: 0.02, tickDecay: 0.05 }
                };
                const p = profiles[style] || profiles.wood;

                // 噪声脉冲 (撞击的"body") 
                const bufSize = Math.floor(audioCtx.sampleRate * 0.12);
                const buffer = audioCtx.createBuffer(1, bufSize, audioCtx.sampleRate);
                const data = buffer.getChannelData(0);
                for (let i = 0; i < bufSize; i++) data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / bufSize, 2);
                const noise = audioCtx.createBufferSource();
                noise.buffer = buffer;

                const filter = audioCtx.createBiquadFilter();
                filter.type = p.type;
                filter.frequency.value = p.freq;
                filter.Q.value = p.q;

                const gain = audioCtx.createGain();
                gain.gain.value = p.vol * intensity;
                gain.gain.exponentialRampToValueAtTime(0.001, now + p.decay);

                noise.connect(filter);
                filter.connect(gain);
                gain.connect(audioCtx.destination);
                noise.start(now);
                noise.stop(now + p.decay + 0.02);

                // metal/原石的高频"余韵"
                if (p.ring) {
                    const osc = audioCtx.createOscillator();
                    const oscGain = audioCtx.createGain();
                    osc.type = 'sine';
                    osc.frequency.value = p.ringFreq;
                    oscGain.gain.value = p.vol * 0.4 * intensity;
                    oscGain.gain.exponentialRampToValueAtTime(0.001, now + p.decay * 1.8);
                    osc.connect(oscGain);
                    oscGain.connect(audioCtx.destination);
                    osc.start(now);
                    osc.stop(now + p.decay * 1.8 + 0.02);
                }

                // 玻璃bead自身的接触"哒"声：极短促的高频瞬态, 叠在Wood/Dark这种低频闷响上面, 
                // 才不会听起来像纯闷的一声——现实里玻璃珠落地总会带一点清脆的尖音
                if (p.tick) {
                    const tickOsc = audioCtx.createOscillator();
                    const tickGain = audioCtx.createGain();
                    tickOsc.type = 'triangle';
                    tickOsc.frequency.value = p.tickFreq;
                    tickGain.gain.value = p.tickVol * intensity;
                    tickGain.gain.exponentialRampToValueAtTime(0.001, now + p.tickDecay);
                    tickOsc.connect(tickGain);
                    tickGain.connect(audioCtx.destination);
                    tickOsc.start(now);
                    tickOsc.stop(now + p.tickDecay + 0.01);
                }

                // Wood特有的空腔共振"哒嗒"声：带通滤波的噪声脉冲, 中心频率落在Wood头
                // 敲击的典型共振区 (约500Hz左右) , 衰减比低频闷响快得多, 
                // 这样Wood听起来会比Dark多一层清亮的"Wood头感", 不会和Dark的闷响混在一起
                if (p.knock) {
                    const knockBufSize = Math.floor(audioCtx.sampleRate * 0.08);
                    const knockBuffer = audioCtx.createBuffer(1, knockBufSize, audioCtx.sampleRate);
                    const knockData = knockBuffer.getChannelData(0);
                    for (let i = 0; i < knockBufSize; i++) knockData[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / knockBufSize, 3);
                    const knockNoise = audioCtx.createBufferSource();
                    knockNoise.buffer = knockBuffer;

                    const knockFilter = audioCtx.createBiquadFilter();
                    knockFilter.type = 'bandpass';
                    knockFilter.frequency.value = p.knockFreq;
                    knockFilter.Q.value = p.knockQ;

                    const knockGain = audioCtx.createGain();
                    knockGain.gain.value = p.knockVol * intensity;
                    knockGain.gain.exponentialRampToValueAtTime(0.001, now + p.knockDecay);

                    knockNoise.connect(knockFilter);
                    knockFilter.connect(knockGain);
                    knockGain.connect(audioCtx.destination);
                    knockNoise.start(now);
                    knockNoise.stop(now + p.knockDecay + 0.02);
                }
            } catch (e) {}
        }

        function flashBead(beadEl) {
            if (!beadEl) return;
            beadEl.style.transition = 'filter 0.1s, box-shadow 0.1s';
            beadEl.style.filter = 'brightness(1.8) drop-shadow(0 0 20px rgba(255,215,0,0.9))';
            beadEl.style.boxShadow = '0 0 30px rgba(255,215,0,0.7)';
            setTimeout(() => {
                beadEl.style.filter = '';
                beadEl.style.boxShadow = '';
            }, 300);
        }

        // ============================================================
        //  7. Destiny Test
        // ============================================================
        function runEnergyTest() {
            const dateStr = document.getElementById('energyBirthDate').value;
            const hourIdx = parseInt(document.getElementById('energyBirthHour').value);
            if (!dateStr) { showToast('Please select your birth date'); return; }
            const parts = dateStr.split('-');
            const year = parseInt(parts[0]),
                month = parseInt(parts[1]),
                day = parseInt(parts[2]);

            const pillars = getPillars(year, month, day, hourIdx);
            const wxCount = getWxCount(pillars);
            const dayGan = pillars.day.gan;
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', ');
            const jiList = xiJi.ji.split(', ');

            appState.lastPillars = pillars;
            appState.lastWxCount = wxCount;
            appState.lastDayGan = dayGan;
            appState.xiList = xiList;
            appState.jiList = jiList;
            appState.hasTested = true;

            // 根据Five ElementsFavorable计算吉祥数字, 并锁定本次Recommended的手链Beads (详见Color & Wearing Advice里的说明) 
            appState.luckyDigits = getLuckyDigits(xiList[0], xiList[1]);
            appState.targetBeadCount = pickTargetBeadCount(appState.luckyDigits);

            // 先根据Destiny生成Recommended的吉祥Beads手链搭配 (数据先算好, DIY Studio页面切换时会自动用上) , 
            // 留在本页展示"Final Report", 不再自动跳转到DIY Studio
            recommendBeads(pillars, wxCount, dayGan);
            renderFinalReport(pillars, wxCount, dayGan);
            setTimeout(() => { soundInspire(); }, 300);
            setTimeout(() => {
                const el = document.getElementById('finalReportArea');
                if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);

            showToast('✅ Destiny test complete — your final report is ready');
        }

        // ============================================================
        //  8. 图表绘制
        // ============================================================

        function drawWuxingWheel(wxCount) {
            const canvas = document.getElementById('r2WuxingWheel');
            if (!canvas) return;
            const ctx = canvas.getContext('2d');
            const w = canvas.parentElement.clientWidth ? Math.min(canvas.parentElement.clientWidth, 260) : 260;
            const h = 220;
            canvas.width = w;
            canvas.height = h;
            ctx.clearRect(0, 0, w, h);

            const order = ['Wood', 'Fire', 'Earth', 'Metal', 'Water']; // Wood生Fire生Earth生Metal生Water生Wood；隔一位相克
            const colors = { 'Wood': '#4caf50', 'Fire': '#e64a3b', 'Earth': '#e0a940', 'Metal': '#c9b896', 'Water': '#2f9fe0' };
            const total = order.reduce((s, k) => s + (wxCount[k] || 0), 0) || 1;

            const cx = w / 2,
                cy = h / 2 - 8;
            const ringR = Math.min(w, h) * 0.34;
            const nodeR = 22;
            const angles = {};
            order.forEach((k, i) => { angles[k] = -Math.PI / 2 + i * (2 * Math.PI / 5); });

            // 相克连线 (穿过圆心的星形) 
            ctx.strokeStyle = 'rgba(160,140,110,0.35)';
            ctx.lineWidth = 1;
            order.forEach((k, i) => {
                const target = order[(i + 2) % 5]; // 隔一位为克
                const a1 = angles[k],
                    a2 = angles[target];
                ctx.beginPath();
                ctx.moveTo(cx + ringR * Math.cos(a1), cy + ringR * Math.sin(a1));
                ctx.lineTo(cx + ringR * Math.cos(a2), cy + ringR * Math.sin(a2));
                ctx.stroke();
            });

            // 相生连线 (外圈弧形箭头, 相邻顺序) 
            ctx.strokeStyle = 'rgba(184,148,95,0.55)';
            ctx.lineWidth = 2;
            order.forEach((k, i) => {
                const next = order[(i + 1) % 5];
                const a1 = angles[k],
                    a2 = angles[next];
                const midA = a1 + (a2 - a1) / 2;
                ctx.beginPath();
                ctx.arc(cx, cy, ringR, a1, a2, false);
                ctx.stroke();
                // 箭头
                const ax = cx + ringR * Math.cos(a2),
                    ay = cy + ringR * Math.sin(a2);
                const tangent = a2 + Math.PI / 2;
                ctx.beginPath();
                ctx.moveTo(ax, ay);
                ctx.lineTo(ax - 6 * Math.cos(tangent - 0.4), ay - 6 * Math.sin(tangent - 0.4));
                ctx.lineTo(ax - 6 * Math.cos(tangent + 0.4), ay - 6 * Math.sin(tangent + 0.4));
                ctx.closePath();
                ctx.fillStyle = 'rgba(184,148,95,0.7)';
                ctx.fill();
            });

            // 五个节点圆
            order.forEach(k => {
                const a = angles[k];
                const nx = cx + ringR * Math.cos(a),
                    ny = cy + ringR * Math.sin(a);
                const val = wxCount[k] || 0;
                const pct = Math.round((val / total) * 100);
                ctx.beginPath();
                ctx.arc(nx, ny, nodeR, 0, 2 * Math.PI);
                ctx.fillStyle = colors[k];
                ctx.globalAlpha = 0.18 + 0.55 * (val / total);
                ctx.fill();
                ctx.globalAlpha = 1;
                ctx.lineWidth = 2;
                ctx.strokeStyle = colors[k];
                ctx.stroke();
                ctx.fillStyle = '#2d1f18';
                ctx.font = 'bold 13px Georgia';
                ctx.textAlign = 'center';
                ctx.fillText(k, nx, ny - 2);
                ctx.font = '10px Georgia';
                ctx.fillStyle = '#6b4f3a';
                ctx.fillText(pct + '%', nx, ny + 12);
            });

            ctx.fillStyle = '#6b4f3a';
            ctx.font = '10px Georgia';
            ctx.textAlign = 'center';
            ctx.fillText('Outer ring generates · inner lines control', cx, h - 6);
        }

        // ============================================================
        //  9. 完整报告
        // ============================================================
        function renderFinalReport(pillars, wxCount, dayGan) {
            const dateStr = document.getElementById('energyBirthDate').value;
            let year, month, day;
            if (dateStr) {
                const parts = dateStr.split('-');
                year = parseInt(parts[0]);
                month = parseInt(parts[1]);
                day = parseInt(parts[2]);
            }
            if (!pillars) {
                if (!dateStr) return;
                const hourIdx = parseInt(document.getElementById('energyBirthHour').value);
                pillars = getPillars(year, month, day, hourIdx);
                wxCount = getWxCount(pillars);
                dayGan = pillars.day.gan;
            }
            const dayWx = WU_XING_GAN[dayGan] || 'Earth';
            const xiJi = getXiJi(dayGan);

            const sub = document.getElementById('finalReportSub');
            if (sub) sub.textContent = `Birth Info: ${dateStr || ''} · Day Master ${dayGan} (${dayWx}) · Favorable ${xiJi.xi}`;

            // ---- r1 BaZi：四柱表格 ----
            const ganList = [pillars.year.gan, pillars.month.gan, pillars.day.gan, pillars.hour.gan];
            const zhiList = [pillars.year.zhi, pillars.month.zhi, pillars.day.zhi, pillars.hour.zhi];
            const pillarTitles = ['Year', 'Month', 'Day', 'Hour'];
            let r1 = '<div class="fr-bazi-grid">';
            for (let i = 0; i < 4; i++) {
                r1 += `<div class="fr-bazi-cell"><div class="pillar">${pillarTitles[i]}</div><div class="gz">${ganList[i]}${zhiList[i]}</div><div class="wx">${WU_XING_GAN[ganList[i]]} / ${WU_XING_ZHI[zhiList[i]]}</div></div>`;
            }
            r1 += '</div>';
            r1 += `<p><strong>Day Master: </strong>${dayGan} (${dayWx}) &nbsp;&nbsp;<strong>Favorable: </strong><span class="hl">${xiJi.xi}</span>&nbsp;&nbsp;<strong>Avoid: </strong>${xiJi.ji}</p>`;

            // ---- r2 Five Elements：数量 + 相生相克 + 旺衰 (不含柱状图/饼图, 只保留下方的Five Elements轮图) ----
            const order = ['Wood', 'Fire', 'Earth', 'Metal', 'Water'];
            const total2 = order.reduce((s, k) => s + (wxCount[k] || 0), 0) || 1;
            let r2 = '<p>';
            order.forEach(wx => {
                const cnt = wxCount[wx] || 0;
                r2 += `${wx}<strong>${cnt}</strong> (${Math.round(cnt / total2 * 100)}%) 　`;
            });
            r2 += '</p>';
            const shengMap2 = { 'Wood': 'Fire', 'Fire': 'Earth', 'Earth': 'Metal', 'Metal': 'Water', 'Water': 'Wood' };
            const keMap2 = { 'Wood': 'Earth', 'Earth': 'Water', 'Water': 'Fire', 'Fire': 'Metal', 'Metal': 'Wood' };
            const shengMe = shengMap2[dayWx] || '',
                keMe = keMap2[dayWx] || '';
            const woSheng = Object.keys(shengMap2).find(k => shengMap2[k] === dayWx) || '';
            const woKe = Object.keys(keMap2).find(k => keMap2[k] === dayWx) || '';
            r2 += `<p><strong>Generating: </strong>${dayWx}→${shengMe} (I generate) , ${woSheng}→${dayWx} (generates me) <br><strong>Controlling: </strong>${dayWx}→${keMe} (I control) , ${woKe}→${dayWx} (controls me) </p>`;
            const selfCnt = wxCount[dayWx] || 0,
                avg2 = total2 / 5;
            if (selfCnt > avg2 * 1.4) r2 += `<p><strong>Strength: </strong><span class="hl">${dayWx} is excessive</span>,  — release and drain it.</p>`;
            else if (selfCnt < avg2 * 0.6) r2 += `<p><strong>Strength: </strong><span class="hl">${dayWx} is weak</span>,  — generate and support it.</p>`;
            else r2 += `<p><strong>Strength: </strong>${dayWx} — balanced and neutral.</p>`;

            // ---- r3 Destiny ----
            const r3 = getMingLiAnalysis(dayGan, wxCount, pillars).map(l => `<p>${l}</p>`).join('');

            // ---- r4 Feng Shui ----
            const r4 = '<ul class="fr-advice-list">' + getFengShuiAdvice(dayGan, wxCount).map(a => `<li>${a}</li>`).join('') + '</ul>';

            // ---- r5 Zodiac / r6 Chinese Zodiac / r7 Zi Wei / r8 Plain Talk ----
            const r5 = (month && day) ? renderZodiacCard(month, day) : '<p>Please select your birth date</p>';
            const r6 = (pillars && pillars.year && pillars.year.zhi) ? renderShengxiaoCard(pillars.year.zhi) : '<p>Please select your birth date</p>';
            const r7 = renderZiweiCard(dayGan);
            const r8 = renderPlainChineseCard(dayGan, wxCount, pillars);

            // ---- r9 Life Stages / r10 过去现在Wei来 / r11 Color & Wearing Advice / r12 Home & Office Decor Advice ----
            const stageLabels = ['🌱 Youth', '🌿 Young Adult', '🌳 Middle Age', '🍂 Senior Years'];
            const r9 = generateLifeStages(dayGan, wxCount, pillars).map((s, i) => `<p><strong>${stageLabels[i]}：</strong>${s}</p>`).join('');
            const r10 = `<p><strong>⏮ Past: </strong>${generateTimeDimension('past', dayGan, wxCount)}</p>
                <p><strong>⏺ Present: </strong>${generateTimeDimension('present', dayGan, wxCount)}</p>
                <p><strong>⏭ Future: </strong>${generateTimeDimension('future', dayGan, wxCount)}</p>`;
            const r11 = renderColorAdviceCard(dayGan, wxCount);
            const r12 = renderFengshuiItemsCard(dayGan, wxCount);

            const cards = [
                { id: 'r1', title: '📜 BaZi', body: r1 },
                { id: 'r2', title: '🌿 Five Elements', body: r2, extra: `<canvas id="r2WuxingWheel" height="200" style="width:100%;max-width:220px;display:block;margin:8px auto 0;"></canvas>` },
                { id: 'r3', title: '🧭 Destiny', body: r3 },
                { id: 'r4', title: '🏮 Feng Shui', body: r4 },
                { id: 'r5', title: '♈ Zodiac', body: r5 },
                { id: 'r6', title: '🐉 Chinese Zodiac', body: r6 },
                { id: 'r7', title: '⭐ Zi Wei', body: r7 },
                { id: 'r8', title: '💬 Plain Talk', body: r8 },
                { id: 'r9', title: '🧬 Life Stages', body: r9 },
                { id: 'r10', title: '⏳ Time Dimension', body: r10 },
                { id: 'r11', title: '🎨 Color & Wearing Advice', body: r11 },
                { id: 'r12', title: '🏡 Home & Office Decor Advice', body: r12 }
            ];
            let gridHtml = '<div class="fr-report-grid">';
            cards.forEach(c => {
                const icon = (c.title.split(' ')[0] || '✨');
                const cardCls = (c.id === 'r1') ? 'report-card bazi-card' : 'report-card'; gridHtml += `<div class="${cardCls}"><div class="rc-watermark">${icon}</div><div class="rc-title">${c.title}</div><div class="rc-body" id="${c.id}">${c.body}</div>${c.extra || ''}</div>`;
            });
            gridHtml += '</div>';

            const _isUnlocked = (function(){ try { return localStorage.getItem('reportUnlocked') === '1'; } catch(e){ return false; } })();
            let html = `<div class="final-report-section">
                <div class="final-report-section-title">🔮 BaZi & Five Elements Destiny</div>
                <div class="report-locked ${_isUnlocked ? 'unlocked' : ''}" id="reportLockedWrap">
                    ${gridHtml}
                </div>
                <div class="report-lock-fade"></div>
                <div class="report-lock-panel">
                    <div class="lock-icon">🔒</div>
                    <h3>Unlock Full Report</h3>
                    <p>Enter the password or purchase to view the complete destiny analysis.</p>
                    <div class="unlock-row">
                        <input type="password" id="reportUnlockPwd" placeholder="Password" />
                        <button class="btn-save-cart save" onclick="unlockReport()">🔓 Unlock</button>
                    </div>
                    <div class="unlock-divider">— or —</div>
                    <button class="btn-save-cart cart" onclick="addReportToCart()">📜 Purchase Full Report · $1</button>
                    <p class="unlock-hint">💡 All products are intelligently generated based on your destiny report to bring you good luck. Unlocking the report is not required to purchase — feel free to scroll down and pick your products.</p>
                </div>
            </div>`;

            // Hot Products (只读快照, 随当前珠盘搭配实时同步) 
            html += `<div class="final-report-section">
                <div class="final-report-section-title">💎 Hot Products</div>
                ${renderBraceletSnapshot()}
            </div>
            <div class="fr-snapshot-actions">
                <button class="btn-save-cart cart" onclick="addDiyCart('numerology')">🛒 Order Bracelet</button>
                <button class="btn-save-cart save" onclick="navigateTo('master')">🎨 Open DIY Studio to Customize</button>
            </div>`;

            // 产品推荐区（分类 tab + 手链卡片 + 发财树卡片）
            html += `<div class="final-report-section">
                <div class="final-report-section-title">🎁 Recommended Products</div>
                <div class="product-cat-tabs">
                    <button class="product-cat-tab active" data-pcat="all" onclick="switchProductCat('all')">All Recommended</button>
                    <button class="product-cat-tab" data-pcat="bracelet" onclick="switchProductCat('bracelet')">Crystal Bracelet</button>
                    <button class="product-cat-tab" data-pcat="ornament" onclick="switchProductCat('ornament')">Ornament</button>
                </div>
                <div id="productGrid">${renderRecommendedProducts('all')}</div>
            </div>`;

            document.getElementById('finalReportSections').innerHTML = html;
            setTimeout(() => drawWuxingWheel(wxCount), 50);
        }

        // ============================================================
        //  10. DIY Studio - 核心
        // ============================================================

        // wrist size 与 Suggested Wrist 的关系：
        // - “Suggested Wrist”只由当前珠盘里实际选中的bead beads粒 (真实 size) 累加算出, 
        //   只要bead的Beads, 大小没有变化, 这个数字就不会变——不会因为你改wrist size而跟着变化；
        // - wrist size这个输入框, 代表你自Ji的Wrist实际size；下面这行提示会实时对比“Suggested Wrist”和
        //   “你的wrist size”. 1cm以内的偏差佩戴时基本感觉不出, 属于正常范围, 不需要调整；
        //   偏差较大时, 优先Advice在Beads不变的前提下, 把same-color的Main Stone/Secondaryswitch to更大或更小的 size (8cm/12cm) 
        //   来贴近Wrist；只有same-colorbead已经调到最大/最小 size, net wrist size依然偏差很大时, 才Advice更换 beads粒数
        //    (即switch to另一档吉祥Beads) , DIY Studio里Beads和beadsize都完全支持修改, 一键即可切换. 
        const BEAD_REAL_MM = { '8cm': 8, '10cm': 10, '12cm': 12 };
        function beadRealMM(bead) {
            if (bead.role === 'spacer' || bead.size === 'metal') return 4; // Metal Spacer Bead体积小, 按约4mm估算
            return BEAD_REAL_MM[bead.size] || 10;
        }
        // 默认根据bead大小 beads粒算出的Suggested Wrist：只取决于当前珠盘里的bead, 不受wrist size输入影响
        function currentSuggestWristCm() {
            if (appState.beads.length === 0) return 0;
            const totalMM = appState.beads.reduce((s, b) => s + beadRealMM(b), 0);
            return Math.round(totalMM) / 10;
        }
        const SPACER_MM = 4;
        // 估算给定Beads, 给定Main Stone/Secondary size (8/10/12mm) 时, 按默认搭配比例
        //  (主/辅/Wealth/Love/Health/Study/隔珠) 生成手链后的net wrist size (cm) ——
        // Wealth/Love/Health/Study珠固定10mm, 隔珠固定约4mm, 只有Main Stone+Secondary的 size会跟着调整
        function estimateAchievedCmForSize(count, sizeMM) {
            const c = computeBraceletCounts(count);
            const mainSecondCount = c.main + c.second;
            const mm = mainSecondCount * sizeMM + 4 * 10 + c.spacer * SPACER_MM;
            return Math.round(mm) / 10;
        }
        function estimateAchievedCm(count) { return estimateAchievedCmForSize(count, 10); }
        // 在吉祥Beads选项里, 找出 (默认10mm size下) net wrist sizeand wrist size is最接近的那一档——只返回一个最优解, 
        // 避免给客户"22 beads还是25 beads"这种选择困难, Five Elements喜用颜色不变, 只是Beads (进而net wrist size) 更贴合Wrist
        function findClosestLuckyCount(wristCm) {
            const options = getLuckyBeadCountOptions(appState.luckyDigits);
            if (!options.length) return appState.targetBeadCount || 18;
            let best = options[0],
                bestDiff = Infinity;
            options.forEach(c => {
                const diff = Math.abs(estimateAchievedCm(c) - wristCm);
                if (diff < bestDiff) { bestDiff = diff; best = c; }
            });
            return best;
        }
        const WRIST_TOLERANCE_CM = 1; // 1cm以内的偏差佩戴时基本感觉不出, 属于正常范围
        function updateWristAdvice() {
            // “Suggested Wrist”这一栏永远只由当前bead的 beads粒大小决定, 跟wrist size输入框无关
            const suggestCm = currentSuggestWristCm();
            document.getElementById('suggestWrist').textContent = suggestCm.toFixed(1);

            const adviceEl = document.getElementById('beadSizeAdvice');
            if (!adviceEl) return;
            const wristInput = document.getElementById('wristSize');
            const wrist = parseFloat(wristInput.value) || 16; // 你自Ji的wrist size, 作为匹配目标
            const applyCountBtn = count => `<button class="btn-save-cart save" style="margin-top:6px;padding:4px 12px;font-size:12px;" onclick="applyRecommendedBeadCount(${count})">🔄 Switch to ${count} beads</button>`;
            const applySizeBtn = sizeMM => `<button class="btn-save-cart save" style="margin-top:6px;padding:4px 12px;font-size:12px;" onclick="applyRecommendedBeadSize(${sizeMM})">🔄 Switch to ${sizeMM}cm size</button>`;

            if (appState.beads.length === 0) {
                const recommended = findClosestLuckyCount(wrist);
                const recommendedCm = Math.round(estimateAchievedCm(recommended));
                adviceEl.innerHTML = `💡 Based on your wrist size of ${wrist}cm, the recommended lucky count is ${recommended} beads of 10cm beads, giving a net wrist size of about ${recommendedCm}cm — a closer fit.`;
                return;
            }

            const currentCount = appState.beads.length;
            const diff = suggestCm - wrist; // 负数=偏小, 正数=偏大
            if (Math.abs(diff) <= WRIST_TOLERANCE_CM) {
                adviceEl.innerHTML = `✅ Your current set (${currentCount} beads) has a suggested net wrist size of about ${Math.round(suggestCm)}cm, which fits your wrist size of ${wrist}cm nicely.`;
                return;
            }

            // 优先方案：Beads不变, 把same-color的Main Stone/Secondaryswitch to更大或更小的 size来贴近Wrist
            const wantBigger = diff < 0;
            const sizeMM = wantBigger ? 12 : 8;
            const sizeCm = estimateAchievedCmForSize(currentCount, sizeMM);
            if (Math.abs(sizeCm - wrist) <= WRIST_TOLERANCE_CM) {
                adviceEl.innerHTML = `💡 Your current set (${currentCount} beads) has a suggested net wrist size of about ${Math.round(suggestCm)}cm, which differs from your wrist size of ${wrist}cm. Try switching the same-color main and secondary stones to ${sizeMM}cm size (same bead count and element colors), giving a net size of about ${Math.round(sizeCm)}cm for a better fit.${applySizeBtn(sizeMM)}`;
                return;
            }

            // same-colorbead已经调到最大/最小 size仍无法贴合, 说明该换一档吉祥Beads了
            const recommended = findClosestLuckyCount(wrist);
            if (recommended === currentCount) {
                adviceEl.innerHTML = `💡 Your current set (${currentCount} beads) has a suggested net wrist size of about ${Math.round(suggestCm)}cm, which differs from your wrist size of ${wrist}cm. Resizing the same-color beads to ${sizeMM}cm gives about ${Math.round(sizeCm)}cm — the closest fit available.${applySizeBtn(sizeMM)}`;
            } else {
                const recommendedCm = Math.round(estimateAchievedCm(recommended));
                adviceEl.innerHTML = `💡 Your current set (${currentCount} beads) has a suggested net wrist size of about ${Math.round(suggestCm)}cm, but your wrist size of ${wrist}cm is quite different. Even resizing the same-color beads won’t fit well, so try switching to ${recommended} beads (a lucky count), giving a net size of about ${recommendedCm}cm for a better fit — with the same element colors.${applyCountBtn(recommended)}`;
            }
        }
        // 一键把Beadsswitch toRecommended的吉祥Beads：保留当前测算出的Five Elements槽位与隔珠材质, 
        // 只是按新的Beads重新生成排列比例 (主/辅/Wealth/Love/Health/Study/隔珠) , 主Secondary统一用默认10cm size
        function applyRecommendedBeadCount(count) {
            if (!appState.braceletSlots) { showToast('Run your destiny test in "Numerology" first'); return; }
            appState.targetBeadCount = count;
            const pattern = generateBraceletPattern();
            const spacerItem = findSpacerItem(appState.spacerMaterial);
            appState.beads = pattern.map(key => {
                if (key === 'spacer') return { ...spacerItem, role: 'spacer', _x: undefined, _y: undefined };
                const wx = appState.braceletSlots[key];
                const item = findCrystalItem(wx, '10cm') || WX_CRYSTAL_ITEMS[0];
                return { ...item, role: key, _x: undefined, _y: undefined };
            });
            appState.isCollapsed = false;
            document.getElementById('beadPlate').classList.remove('collapsed');
            renderBeads();
            renderMaterials();
            showToast(`✨ Switched to ${count} lucky beads`);
        }
        // 一键把Main Stone/Secondary统一switch to指定 size (8cm/12cm等) , Beads, Five Elements配色, WealthLoveHealthStudy珠, 隔珠都不变
        function applyRecommendedBeadSize(sizeMM) {
            if (appState.beads.length === 0) return;
            const sizeKey = `${sizeMM}cm`;
            appState.beads = appState.beads.map(b => {
                if (b.role !== 'main' && b.role !== 'second') return b;
                const item = findCrystalItem(b.wx, sizeKey);
                if (!item) return b;
                return { ...item, role: b.role, _x: undefined, _y: undefined };
            });
            renderBeads();
            renderMaterials();
            showToast(`✨ Main/secondary stones switched to ${sizeKey} size`);
        }


        function renderBeads() {
            const container = document.getElementById('beadContainer');
            if (!container) return;
            const count = appState.beads.length;
            document.getElementById('beadCount').textContent = count;
            const totalPrice = appState.beads.reduce((s, b) => s + (b.price || 0), 0);
            document.getElementById('beadTotal').textContent = totalPrice;

            updateWristAdvice();

            if (count === 0) {
                container.innerHTML = '';
                document.getElementById('beadPlate').classList.remove('collapsed');
                document.getElementById('collapseBtn').textContent = '📿 Gather into a strand';
                appState.isCollapsed = false;
                document.getElementById('plateLogo').style.opacity = '1';
                return;
            }
            document.getElementById('plateLogo').style.opacity = '0';

            // 修复bead圆心与珠盘圆心不对齐的问题：珠盘现在是椭圆容器 (贴合实拍照片的真实长宽比) , 
            // 用真实渲染的宽高算圆心/边界, 绝对不再用写死的正方形坐标系. 
            const plateEl = document.getElementById('beadPlate');
            const pw = (plateEl && plateEl.clientWidth) || 420;
            const ph = (plateEl && plateEl.clientHeight) || (pw / 1);
            const cx = pw / 2,
                cy = ph / 2;
            const rx = pw / 2 * 0.82,
                ry = ph / 2 * 0.82;
            let html = '';
            const isCollapsed = appState.isCollapsed;

            let ringLayout = null;
            if (isCollapsed) {
                // 收拢成串：手链贴合珠盘本身的椭圆角度摆放, 圆心与珠盘圆心完全重合, 
                // 半径由bead真实size累计的周长决定, 也不会超出珠盘可容纳的范围
                ringLayout = computeRingLayout(appState.beads, cx, cy, 1, rx * 0.92, ry * 0.92);
            }

            appState.beads.forEach((bead, i) => {
                let x, y, beadSize;
                if (isCollapsed) {
                    x = ringLayout.positions[i].x;
                    y = ringLayout.positions[i].y;
                    beadSize = ringLayout.positions[i].size;
                } else {
                    if (bead._x === undefined || bead._y === undefined) {
                        const attempts = 30;
                        let found = false;
                        for (let t = 0; t < attempts; t++) {
                            const px = cx + (Math.random() * 2 - 1) * rx * 0.9;
                            const py = cy + (Math.random() * 2 - 1) * ry * 0.9;
                            const inEllipse = ((px - cx) / rx) ** 2 + ((py - cy) / ry) ** 2 <= 0.85;
                            if (inEllipse) {
                                let overlap = false;
                                for (let j = 0; j < i; j++) {
                                    const prev = appState.beads[j];
                                    if (prev._x !== undefined && prev._y !== undefined) {
                                        const d = Math.sqrt((px - prev._x) ** 2 + (py - prev._y) ** 2);
                                        if (d < 28) { overlap = true; break; }
                                    }
                                }
                                if (!overlap) { x = px;
                                    y = py;
                                    found = true; break; }
                            }
                        }
                        if (!found) {
                            const angle = Math.random() * 2 * Math.PI;
                            x = cx + rx * 0.6 * Math.cos(angle);
                            y = cy + ry * 0.6 * Math.sin(angle);
                        }
                        bead._x = x;
                        bead._y = y;
                    } else {
                        x = bead._x;
                        y = bead._y;
                    }
                    // 按真实 size (8/10/12cm) 等比例缩放bead显示直径, 不再是随机大小
                    beadSize = beadPxSize(bead, 1);
                }
                const color = bead.color || '#888';
                const beadImgVar = getBeadImgVar(bead);
                const fit = getFit(bead.wx);
                const fitClass = fit === 'Recommended' ? 'fit-good' : fit === 'Use with Caution' ? 'fit-bad' : 'fit-neutral';
                const wxName = bead.wx || 'None';
                html += `
                    <div class="bead" style="
                        left:${x - beadSize/2}px;
                        top:${y - beadSize/2}px;
                        width:${beadSize}px;
                        height:${beadSize}px;
                        --bead-color:${color};
                        --bead-img:${beadImgVar};
                        ${isCollapsed ? 'transition: left 0.55s cubic-bezier(0.22, 0.61, 0.36, 1), top 0.55s cubic-bezier(0.22, 0.61, 0.36, 1), width 0.4s, height 0.4s;' : ''}
                    " data-idx="${i}" title="Drag to reposition · click to remove">
                        <span class="bead-label">
                            ${bead.name}
                            <span class="size-price">${bead.size||''} · $${bead.price}</span>
                            <span class="wx-fit ${fitClass}">${fit} · ${wxName}${bead.wx ? ' (' + bead.wx + ') ' : ''}</span>
                        </span>
                    </div>
                `;
            });
            container.innerHTML = html;
            document.getElementById('collapseBtn').textContent = isCollapsed ? '💫 Expand' : '📿 Gather into a strand';
            updateWxExplanation();
        }

        function updateWxExplanation() {
            const el = document.getElementById('wxExplanation');
            if (!el) return;
            const count = appState.beads.length;
            if (count === 0) {
                el.innerHTML = '💡 <strong>Five Elements Reading: </strong>Add beads and the system will offer adjustments based on your favorable elements and bead colors.';
                return;
            }
            if (!appState.hasTested) {
                el.innerHTML = '💡 <strong>Five Elements Reading: </strong>Run your destiny test in "Numerology" first to get personalized advice.';
                return;
            }
            el.innerHTML = `💡 <strong>Five Elements Reading: </strong>${buildCompositionSummaryText()}<br>${buildWxAdviceText()}${buildLuckyCountNote()}`;
        }

        // 在Five Elements解读里追加一句吉祥Beads智能匹配说明：当前Beads是否已是吉祥数字
        function buildLuckyCountNote() {
            const options = getLuckyBeadCountOptions(appState.luckyDigits);
            if (!options.length) return '';
            const count = appState.beads.length;
            if (options.includes(count)) {
                return `<br>🔢 <strong>Bead Count Check: </strong>You currently have ${count} beads — one of your lucky counts, resonating well with your elemental energy.`;
            }
            return `<br>🔢 <strong>Bead Count Check: </strong>You currently have ${count} beads — not among your lucky counts (${options.join(', ')}). In "DIY Studio", switch to the lucky count that best fits your wrist size.`;
        }

        // bead有改动时, 结合DestinyFavorable实时给出Adjustment Advice: 当前搭配偏向哪个Five Elements, 
        // 是否碰到了Avoid element, 该switch to哪种颜色的crystal更合适
        function buildWxAdviceText() {
            const xiList = appState.xiList || [],
                jiList = appState.jiList || [];
            if (xiList.length === 0) return '';
            const counts = {};
            appState.beads.forEach(b => { if (b.wx) counts[b.wx] = (counts[b.wx] || 0) + 1; });

            // Avoid element里数量Maximum 的 (按数量降序) , 代表最需要替换的
            const jiPresent = jiList.filter(w => counts[w] > 0).sort((a, b) => (counts[b] || 0) - (counts[a] || 0));
            // Favorable里数量最少的 (含0) , 代表最值得补充的
            const xiSorted = [...xiList].sort((a, b) => (counts[a] || 0) - (counts[b] || 0));
            const weakestXi = xiSorted[0];
            const weakestXiItem = findCrystalItem(weakestXi, '10cm');
            const weakestXiName = weakestXiItem ? stripSize(weakestXiItem.name) : (weakestXi + 'crystal');

            if (jiPresent.length > 0) {
                const badWx = jiPresent[0];
                const badItem = findCrystalItem(badWx, '10cm');
                const badName = badItem ? stripSize(badItem.name) : (badWx + 'crystal');
                return `⚠️ <strong>Adjustment Advice: </strong>Your bracelet currently has ${badWx} of the "${badName}" element (e.g. ${counts[badWx]}), which is your avoid element — replace them with "${weakestXi}" element ${weakestXiName} to better align with your favorable elements.`;
            }
            if ((counts[weakestXi] || 0) === 0) {
                return `💡 <strong>Adjustment Advice: </strong>Your bracelet has no "${weakestXi}" element crystals yet — add a few ${weakestXiName} to strengthen your favorable elements.`;
            }
            return `✅ <strong>Adjustment Advice: </strong>Your current set aligns well with your favorable elements "${xiList.join(', ')}" — well balanced, no adjustment needed.`;
        }

        function toggleCollapse() {
            if (appState.beads.length === 0) { showToast('Please add beads first'); return; }
            appState.isCollapsed = !appState.isCollapsed;
            if (appState.isCollapsed) { soundCollapse();
                document.getElementById('beadPlate').classList.add('collapsed'); } else { soundScatter();
                document.getElementById('beadPlate').classList.remove('collapsed'); }
            renderBeads();
        }

        // ---- 坠落动画：5秒真实物理 ----
        // 流程：18 beads起始"串在一根绳Zi上" (顶部弧形排列) → 逐 beads依次脱绳, 自由落体
        // → 撞击珠盘边缘 (椭圆边界, 按Wood/原石/Gold/Dark给不同弹性系数+音色) → bead间真实弹性碰撞
        // → each bead落到盘面后就"着地", 重力随之关闭 (只剩摩擦力+微弱向心力+碰撞) , 
        //   这样最终会自然散落在整个盘面上, 而不是像先前那样持续受重力牵引, 全部堆在盘Zi底部. 
        function startFallAnimation() {
            if (appState.beads.length === 0 || appState.animating) return;
            appState.animating = true;
            const container = document.getElementById('beadContainer');
            const beads = container.querySelectorAll('.bead');
            if (beads.length === 0) { appState.animating = false; return; }

            const plateEl2 = document.getElementById('beadPlate');
            const pw = (plateEl2 && plateEl2.clientWidth) || 420;
            const ph = (plateEl2 && plateEl2.clientHeight) || (pw / 1);
            const cx = pw / 2,
                cy = ph / 2;
            const rx = pw / 2 * 0.82,
                ry = ph / 2 * 0.82;
            const style = appState.plateStyle || 'wood';
            // 弹性系数按参考视频里各材质的真实弹跳表现调过：metalGold盘最硬, 弹得最高最脆；
            // Dark盘偏哑光陶瓷质感, 弹性其次；Wood盘最吸震, 弹得最低最快停下
            const restitution = { wood: 0.38, stone: 0.68, gold: 0.6, dark: 0.5 }[style] || 0.5;

            beads.forEach(el => el.classList.add('physics'));

            const n = beads.length;
            const positions = [],
                velocities = [],
                landedAt = [];
            beads.forEach((el, i) => {
                const w = parseFloat(el.style.width) || 24;
                const h = parseFloat(el.style.height) || 24;
                // 起始状态：像串在一根绳Zi上, 顶部微弧排列
                const spread = Math.min(pw - 30, n * 17);
                const t = n > 1 ? i / (n - 1) : 0.5;
                const x = cx - spread / 2 + spread * t;
                const y = -18 - Math.sin(t * Math.PI) * 10;
                positions.push({ x, y, w, h });
                velocities.push({ vx: (Math.random() - 0.5) * 1.4, vy: 0 });
                landedAt.push(null);
                el.style.left = (x - w / 2) + 'px';
                el.style.top = (y - h / 2) + 'px';
            });

            const totalDurationMs = 5000;
            const baseGravity = 0.16; // 调小重力, 避免bead在这么小的珠盘范围内加速过猛, 撞底后又弹回堆在另一侧
            const fallPhaseMs = 850; // each bead"自由落体"的时长, 之后重力关闭, 自然停在盘面上
            const airFriction = 0.992;
            const settleFriction = 0.9; // 着地后额外摩擦力, 让bead较快静止分散, 不再持续滑动
            const dropStagger = Math.min(45, 900 / n); // 依次"脱绳"下落, 制造真实的错落感
            const startTime = performance.now();
            let lastSoundTime = 0;
            // each bead重力/初速度略differs, 落点自然分散在盘面各处, 而不是整齐划一地落到同一深度
            const gravityMul = positions.map(() => 0.75 + Math.random() * 0.5);
            // each bead给一个随机的"个人空间"系数, 让bead落定后彼此间距有大有小, 不是统一的等距排列, 
            // 更像真实倒出来的散bead, 而不是被摆成整齐的间隔
            const spacingFactor = positions.map(() => 0.85 + Math.random() * 0.7);

            function throttledImpact(now, intensity) {
                if (now - lastSoundTime > 45) { // 避免同一帧多次撞击把音效叠成噪音
                    playImpactSound(style, intensity);
                    lastSoundTime = now;
                }
            }

            function frame(now) {
                const elapsed = now - startTime;
                let stillMoving = false;

                positions.forEach((p, i) => {
                    const detachTime = i * dropStagger;
                    if (elapsed < detachTime) { stillMoving = true; return; }

                    const fallElapsed = elapsed - detachTime;
                    if (fallElapsed < fallPhaseMs) {
                        // 下落阶段：重力牵引 (每 beads力度略differs) 
                        velocities[i].vy += baseGravity * gravityMul[i];
                    } else {
                        // 着地阶段：不再有方向性的重力牵引, 只靠摩擦力自然停下 —— 落点因此分散在整个盘面, 
                        // 不会像持续受重力那样最终都滑积到盘Zi底部
                        velocities[i].vx *= settleFriction;
                        velocities[i].vy *= settleFriction;
                    }
                    p.x += velocities[i].vx;
                    p.y += velocities[i].vy;

                    // 轻微向心力：只在下落阶段用来防止bead全部飞到贴着盘边, 
                    // 一旦落地进入摩擦定住阶段就不再持续往中心拉, 否则会让18 beads
                    // 慢慢又聚拢黏在盘Zi中间, 散不开
                    if (fallElapsed < fallPhaseMs) {
                        velocities[i].vx += (cx - p.x) * 0.0006;
                        velocities[i].vy += (cy - p.y) * 0.0006;
                    }

                    // 椭圆边界碰撞 (贴合真实珠盘的长宽比, 不再是正圆) 
                    const nrx = rx - p.w / 2,
                        nry = ry - p.h / 2;
                    const ex = (p.x - cx) / nrx,
                        ey = (p.y - cy) / nry;
                    const edist = Math.sqrt(ex * ex + ey * ey) || 0.001;
                    if (edist > 1) {
                        p.x = cx + (ex / edist) * nrx;
                        p.y = cy + (ey / edist) * nry;
                        // 椭圆法线方向 (按长短轴归一化) 
                        const nx0 = ex / nrx,
                            ny0 = ey / nry;
                        const nlen = Math.hypot(nx0, ny0) || 1;
                        const nx = nx0 / nlen,
                            ny = ny0 / nlen;
                        const dot = velocities[i].vx * nx + velocities[i].vy * ny;
                        if (dot > 0) {
                            const speed = Math.hypot(velocities[i].vx, velocities[i].vy);
                            velocities[i].vx -= (1 + restitution) * dot * nx;
                            velocities[i].vy -= (1 + restitution) * dot * ny;
                            if (speed > 0.7) throttledImpact(now, Math.min(1, speed / 9));
                        }
                    }

                    velocities[i].vx *= airFriction;
                    velocities[i].vy *= airFriction;

                    if (Math.abs(velocities[i].vx) > 0.05 || Math.abs(velocities[i].vy) > 0.05 || fallElapsed < fallPhaseMs) {
                        stillMoving = true;
                    }
                });

                // bead间真实弹性碰撞 (等质量, 沿碰撞法线交换动量, 边缘贴近但不会互相嵌入) 
                for (let i = 0; i < positions.length; i++) {
                    if (elapsed < i * dropStagger) continue;
                    for (let j = i + 1; j < positions.length; j++) {
                        if (elapsed < j * dropStagger) continue;
                        const p1 = positions[i],
                            p2 = positions[j];
                        const dx = p2.x - p1.x,
                            dy = p2.y - p1.y;
                        const dist = Math.hypot(dx, dy) || 0.01;
                        const minDist = (p1.w + p2.w) / 2 * ((spacingFactor[i] + spacingFactor[j]) / 2);
                        if (dist < minDist) {
                            const nx = dx / dist,
                                ny = dy / dist;
                            const overlap = minDist - dist;
                            p1.x -= nx * overlap / 2;
                            p1.y -= ny * overlap / 2;
                            p2.x += nx * overlap / 2;
                            p2.y += ny * overlap / 2;
                            const v1 = velocities[i],
                                v2 = velocities[j];
                            const relVx = v1.vx - v2.vx,
                                relVy = v1.vy - v2.vy;
                            const rel = relVx * nx + relVy * ny;
                            if (rel > 0) {
                                const imp = rel * restitution;
                                v1.vx -= imp * nx;
                                v1.vy -= imp * ny;
                                v2.vx += imp * nx;
                                v2.vy += imp * ny;
                                if (Math.abs(rel) > 0.6) throttledImpact(now, Math.min(1, Math.abs(rel) / 7));
                            }
                            stillMoving = true;
                        }
                    }
                }

                beads.forEach((el, i) => {
                    const p = positions[i];
                    el.style.left = (p.x - p.w / 2) + 'px';
                    el.style.top = (p.y - p.h / 2) + 'px';
                });

                if (elapsed < totalDurationMs && stillMoving) {
                    requestAnimationFrame(frame);
                } else {
                    appState.animating = false;
                    beads.forEach((el, i) => {
                        el.classList.remove('physics');
                        const left = parseFloat(el.style.left),
                            top = parseFloat(el.style.top);
                        const w = parseFloat(el.style.width) || 24,
                            h = parseFloat(el.style.height) || 24;
                        if (appState.beads[i]) {
                            appState.beads[i]._x = left + w / 2;
                            appState.beads[i]._y = top + h / 2;
                        }
                    });
                    renderBeads();
                    showToast('✨ Beads settled');
                }
            }
            requestAnimationFrame(frame);
        }

        function scatterBeads() {
            if (appState.beads.length === 0) return;
            if (appState.isCollapsed) {
                appState.isCollapsed = false;
                document.getElementById('beadPlate').classList.remove('collapsed');
                soundScatter();
                renderBeads();
                return;
            }
            appState.beads.forEach(b => { b._x = undefined;
                b._y = undefined; });
            renderBeads();
            setTimeout(() => startFallAnimation(), 200);
            showToast('💫 Beads scattered');
        }

        function inspireBeads() {
            if (appState.beads.length === 0) { showToast('Please add beads first'); return; }
            appState.beads.forEach(b => { b._x = undefined;
                b._y = undefined; });
            renderBeads();
            soundInspire();
            document.querySelectorAll('#beadContainer .bead').forEach(el => {
                setTimeout(() => flashBead(el), Math.random() * 300);
            });
            setTimeout(() => startFallAnimation(), 400);
            showToast('✨ Beads inspired · energy activated');
        }

        function removeBead(idx) {
            if (idx >= 0 && idx < appState.beads.length) {
                const name = appState.beads[idx].name;
                appState.beads.splice(idx, 1);
                soundRemove();
                renderBeads();
                renderMaterials();
                showToast(`➖ Removed  ${name}`);
            }
        }

        // ---- bead拖曳 ----
        // 打散状态：bead可以在珠盘范围内自由拖曳, 只要求不超出珠盘椭圆边界；
        // 收拢成串状态：bead只能沿着已经串好的圆环调整彼此的先后位置 (拖到哪 beads附近, 
        // 就与那 beads互换位置) , 手链本身的圆环形状不会被拖散. 
        // 单纯点击 (没有明显拖动) 时, 保持原来的"点击移除"行为. 
        let beadDragCtx = null;
        function setupBeadDrag() {
            const container = document.getElementById('beadContainer');
            const plateEl = document.getElementById('beadPlate');
            if (!container || !plateEl) return;

            container.addEventListener('pointerdown', function(e) {
                const beadEl = e.target.closest('.bead');
                if (!beadEl || !container.contains(beadEl)) return;
                const idx = parseInt(beadEl.dataset.idx, 10);
                if (isNaN(idx) || !appState.beads[idx]) return;
                const rect = plateEl.getBoundingClientRect();
                beadDragCtx = {
                    beadEl,
                    bead: appState.beads[idx],
                    startX: e.clientX,
                    startY: e.clientY,
                    moved: false,
                    rect,
                    cx: rect.width / 2,
                    cy: rect.height / 2,
                    rx: rect.width / 2 * 0.82,
                    ry: rect.height / 2 * 0.82,
                    wasCollapsed: appState.isCollapsed,
                    lastSwapTime: 0,
                    pointerId: e.pointerId
                };
                beadEl.classList.add('dragging');
                if (beadEl.setPointerCapture) {
                    try { beadEl.setPointerCapture(e.pointerId); } catch (err) {}
                }
            });

            container.addEventListener('pointermove', function(e) {
                const ctx = beadDragCtx;
                if (!ctx) return;
                const dx = e.clientX - ctx.startX;
                const dy = e.clientY - ctx.startY;
                if (Math.abs(dx) > 4 || Math.abs(dy) > 4) ctx.moved = true;
                if (!ctx.moved) return;

                let px = e.clientX - ctx.rect.left;
                let py = e.clientY - ctx.rect.top;

                if (!ctx.wasCollapsed) {
                    // 自由拖曳, 超出椭圆边界就贴着边界停住
                    const ex = (px - ctx.cx) / ctx.rx;
                    const ey = (py - ctx.cy) / ctx.ry;
                    const distSq = ex * ex + ey * ey;
                    if (distSq > 1) {
                        const scale = 1 / Math.sqrt(distSq);
                        px = ctx.cx + (px - ctx.cx) * scale;
                        py = ctx.cy + (py - ctx.cy) * scale;
                    }
                    ctx.bead._x = px;
                    ctx.bead._y = py;
                    const size = beadPxSize(ctx.bead, 1);
                    ctx.beadEl.style.left = (px - size / 2) + 'px';
                    ctx.beadEl.style.top = (py - size / 2) + 'px';
                } else {
                    // 沿圆环调整位置：算出当前圆环上each bead的角度, 拖到哪 beads附近就与它互换
                    const layout = computeRingLayout(appState.beads, ctx.cx, ctx.cy, 1, ctx.rx * 0.92, ctx.ry * 0.92);
                    const pointerAngle = Math.atan2((py - ctx.cy) / layout.ry, (px - ctx.cx) / layout.rx);
                    const curIdx = appState.beads.indexOf(ctx.bead);
                    let nearestIdx = -1,
                        nearestDiff = Infinity;
                    layout.positions.forEach((pos, i) => {
                        if (i === curIdx) return;
                        const a = Math.atan2((pos.y - ctx.cy) / layout.ry, (pos.x - ctx.cx) / layout.rx);
                        let diff = Math.abs(pointerAngle - a);
                        if (diff > Math.PI) diff = 2 * Math.PI - diff;
                        if (diff < nearestDiff) { nearestDiff = diff; nearestIdx = i; }
                    });
                    const now = Date.now();
                    if (nearestIdx !== -1 && nearestIdx !== curIdx && now - ctx.lastSwapTime > 180) {
                        const tmp = appState.beads[curIdx];
                        appState.beads[curIdx] = appState.beads[nearestIdx];
                        appState.beads[nearestIdx] = tmp;
                        ctx.lastSwapTime = now;
                        renderBeads();
                        const newIdx = appState.beads.indexOf(ctx.bead);
                        const newEl = container.querySelector('.bead[data-idx="' + newIdx + '"]');
                        if (newEl) {
                            newEl.classList.add('dragging');
                            ctx.beadEl = newEl;
                        }
                    }
                }
            });

            function endDrag(e) {
                const ctx = beadDragCtx;
                if (!ctx) return;
                beadDragCtx = null;
                ctx.beadEl.classList.remove('dragging');
                if (!ctx.moved) {
                    // 没有拖动位移, 视为普通点击：移除这 beads
                    const idx = appState.beads.indexOf(ctx.bead);
                    if (idx !== -1) removeBead(idx);
                } else if (ctx.wasCollapsed) {
                    renderBeads();
                } else {
                    updateWxExplanation();
                }
            }
            container.addEventListener('pointerup', endDrag);
            container.addEventListener('pointercancel', endDrag);
        }

        function undoBead() {
            if (appState.beads.length === 0) { showToast('No beads to remove'); return; }
            const name = appState.beads.pop().name;
            soundRemove();
            renderBeads();
            renderMaterials();
            showToast(`↩️ Remove ${name}`);
        }

        function clearBeads() {
            if (appState.beads.length === 0) return;
            appState.beads = [];
            appState.isCollapsed = false;
            document.getElementById('beadPlate').classList.remove('collapsed');
            renderBeads();
            renderMaterials();
            showToast('🗑️ Cleared');
        }

        function saveBracelet() {
            if (appState.beads.length === 0) { showToast('Please add beads first'); return; }
            const wrist = document.getElementById('wristSize').value;
            showToast(`💾 Bracelet saved (${appState.beads.length} beads, wrist size${wrist}cm)`);
        }

        function generateRandomBeads(count) {
            const allItems = Object.values(MATERIALS).flat();
            const shuffled = allItems.sort(() => Math.random() - 0.5);
            const selected = shuffled.slice(0, count);
            appState.beads = selected.map(item => ({ ...item, _x: undefined, _y: undefined }));
            appState.isCollapsed = false;
            document.getElementById('beadPlate').classList.remove('collapsed');
            renderBeads();
            renderMaterials();
            setTimeout(() => soundInspire(), 200);
            setTimeout(() => {
                document.querySelectorAll('#beadContainer .bead').forEach(el => {
                    setTimeout(() => flashBead(el), Math.random() * 400);
                });
            }, 300);
            setTimeout(() => startFallAnimation(), 500);
            showToast('✨ Random beads generated');
        }

        // Five Elements → 结构性 corresponding to关系 (财星/夫妻宫/印星) , 用于自动匹配Wealth Bead/Love Bead/Study贵人珠
        const WX_KE_MAP = { 'Wood': 'Earth', 'Fire': 'Metal', 'Earth': 'Water', 'Metal': 'Wood', 'Water': 'Fire' };
        const WX_SHENG_MAP = { 'Wood': 'Water', 'Fire': 'Wood', 'Earth': 'Fire', 'Metal': 'Earth', 'Water': 'Metal' };
        // 若结构上 corresponding to的Five Elements恰好是Avoid element, 一律回退为Favorable, 绝不默认RecommendedAvoid element色
        function pickBeneficialWx(candidate, xiList, jiList, fallback) {
            if (xiList.includes(candidate)) return candidate;
            if (!jiList.includes(candidate)) return candidate;
            return fallback;
        }
        function generateBraceletSlots(dayGan, wuXingCount, pillars) {
            const dayWx = WU_XING_GAN[dayGan] || 'Earth';
            const xiJi = getXiJi(dayGan);
            const xiList = xiJi.xi.split(', '),
                jiList = xiJi.ji.split(', ');
            const mainWx = xiList[0] || 'Wood';
            const secondWx = xiList[1] || xiList[0] || 'Fire';
            const wealthWx = pickBeneficialWx(WX_KE_MAP[dayWx] || 'Earth', xiList, jiList, mainWx);
            const marriageWx = pickBeneficialWx(WU_XING_ZHI[pillars.day.zhi] || 'Earth', xiList, jiList, secondWx);
            const studyWx = pickBeneficialWx(WX_SHENG_MAP[dayWx] || 'Water', xiList, jiList, mainWx);
            let healthWx;
            if (xiList.length > 0) {
                const xiSorted = [...xiList].sort((a, b) => (wuXingCount[a] || 0) - (wuXingCount[b] || 0));
                healthWx = xiSorted[0];
            } else {
                const sorted = Object.entries(wuXingCount).sort((a, b) => a[1] - b[1]);
                healthWx = sorted[0] ? sorted[0][0] : 'Water';
            }
            return {
                xiList, jiList,
                slots: { main: mainWx, second: secondWx, wealth: wealthWx, marriage: marriageWx, health: healthWx, study: studyWx },
                spacerMaterial: (mainWx === 'Metal') ? 'silver' : 'gold'
            };
        }
        // 排列：主/Secondary按比例公平交错, 再把专属珠, 隔珠均匀插入整圈
        // Beads不再固定为18 beads, 而是按appState.targetBeadCount (吉祥Beads, 见Five ElementsFavorable+吉祥数字推算) 动态生成, 
        // Wealth/Love/Health/Study珠各固定1 beads, Main Stone:Secondary按约2:1分配, 隔珠按约1/8比例分配 (与原18 beads时main8/second4/spacer2的比例一致) 
        function computeBraceletCounts(total) {
            total = total || 18;
            const specials = 4; // wealth/marriage/health/study  — 1 bead each
            let rest = total - specials;
            if (rest < 4) rest = 4; // 极端情况下的保护
            let spacer = Math.max(1, Math.round(rest * (2 / 16)));
            let mainSecond = rest - spacer;
            let second = Math.max(1, Math.round(mainSecond * (4 / 12)));
            let main = mainSecond - second;
            if (main < 1) main = 1;
            return { main, second, wealth: 1, marriage: 1, health: 1, study: 1, spacer };
        }
        function fairInterleave(mainCount, secondCount) {
            const arr = new Array(mainCount + secondCount).fill('main');
            if (secondCount > 0) {
                const step = (mainCount + secondCount) / secondCount;
                for (let k = 0; k < secondCount; k++) arr[Math.min(Math.round(k * step), arr.length - 1)] = 'second';
            }
            return arr;
        }
        function insertEvenly(base, inserts) {
            const out = [...base];
            const n = inserts.length;
            if (!n) return out;
            const finalLen = out.length + n;
            const step = finalLen / n;
            for (let i = 0; i < n; i++) {
                const pos = Math.min(Math.round((i + 0.5) * step), out.length);
                out.splice(pos, 0, inserts[i]);
            }
            return out;
        }
        function roundRobinSpecials(counts) {
            const keys = ['wealth', 'marriage', 'health', 'study'];
            const remain = { wealth: counts.wealth, marriage: counts.marriage, health: counts.health, study: counts.study };
            const out = [];
            let any = true;
            while (any) { any = false;
                for (const k of keys) { if (remain[k] > 0) { out.push(k); remain[k]--; any = true; } } }
            return out;
        }
        function generateBraceletPattern() {
            const counts = computeBraceletCounts(appState.targetBeadCount || 18);
            const base = fairInterleave(counts.main, counts.second);
            const withSpecials = insertEvenly(base, roundRobinSpecials(counts));
            return insertEvenly(withSpecials, new Array(counts.spacer).fill('spacer'));
        }
        function findCrystalItem(wx, size) {
            size = size || '10cm';
            return WX_CRYSTAL_ITEMS.find(it => it.wx === wx && it.size === size) || WX_CRYSTAL_ITEMS.find(it => it.wx === wx);
        }
        function findSpacerItem(material) {
            return material === 'silver' ? SPACER_ITEMS[1] : SPACER_ITEMS[0];
        }

        function recommendBeads(pillars, wuXingCount, dayGan) {
            const data = generateBraceletSlots(dayGan, wuXingCount, pillars);
            appState.xiList = data.xiList;
            appState.jiList = data.jiList;
            appState.braceletSlots = data.slots;
            appState.spacerMaterial = data.spacerMaterial;

            const pattern = generateBraceletPattern();
            const spacerItem = findSpacerItem(data.spacerMaterial);
            appState.beads = pattern.map(key => {
                if (key === 'spacer') return { ...spacerItem, role: 'spacer', _x: undefined, _y: undefined };
                const wx = data.slots[key];
                const item = findCrystalItem(wx, '10cm') || WX_CRYSTAL_ITEMS[0];
                return { ...item, role: key, _x: undefined, _y: undefined };
            });

            appState.isCollapsed = false;
            document.getElementById('beadPlate').classList.remove('collapsed');
            renderBeads();
            renderMaterials();
            setTimeout(() => soundInspire(), 300);
            setTimeout(() => {
                document.querySelectorAll('#beadContainer .bead').forEach(el => {
                    setTimeout(() => flashBead(el), Math.random() * 400);
                });
            }, 400);
            setTimeout(() => startFallAnimation(), 600);
            showToast(`✨ Recommended ${appState.beads.length} lucky beads`);
        }

        // 手链搭配文字说明 ("This bracelet has 18 beads, 以"Fire"系 red agate 为Main Stone……"这段模板) 
        const ROLE_LABEL = { wealth: 'Wealth Bead', marriage: 'Love Bead', health: 'Health Bead', study: 'Study/Mentor Bead' };
        function stripSize(name) { return (name || '').replace(/\s*\d+cm$/, ''); }
        function buildCompositionSummaryText() {
            const beads = appState.beads;
            if (beads.length === 0) return '';
            const byRole = { main: [], second: [], wealth: [], marriage: [], health: [], study: [], spacer: [] };
            beads.forEach(b => { const r = byRole[b.role] ? b.role : 'main';
                byRole[r].push(b); });
            const mainB = byRole.main[0],
                secondB = byRole.second[0],
                spacerB = byRole.spacer[0];
            const parts = [`This bracelet has  ${beads.length} beads`];
            if (mainB) parts.push(`Centered on "${mainB.wx}" element ${stripSize(mainB.name)}  as the main stones (echoing your favorable element and career direction, ${byRole.main.length} beads)`);
            if (secondB) parts.push(`paired with "${secondB.wx}" element ${stripSize(secondB.name)}  as accent stones to balance the energy (${byRole.second.length} beads)`);
            const specials = ['wealth', 'marriage', 'health', 'study'].filter(k => byRole[k][0])
                .map(k => `${ROLE_LABEL[k]} (${byRole[k][0].wx}) `).join(', ');
            if (specials) parts.push(`Also embedded with ${specials} — 1 bead each`);
            if (spacerB) parts.push(`Separated by ${stripSize(spacerB.name)} for structure, balancing meaning and design`);
            return parts.join(',  ') + '. ';
        }

        // Final Report里的手链只读快照：环形排布贴合珠盘 + 中心穿线圈, 圆心与珠盘圆心严格对齐；
        // 统一固定用Wood珠盘展示 (不随DIY Studio里选的珠盘样式变化) 
        function renderBraceletSnapshot() {
            const beads = appState.beads;
            if (beads.length === 0) {
                return '<div class="empty-tip" style="text-align:center;color:var(--text-secondary);font-size:13px;padding:12px 0;">Please run your destiny test first — the system will auto-generate a recommended set.</div>';
            }
            const trayW = 260,
                trayH = trayW,
                cx = trayW / 2,
                cy = trayH / 2;
            // NumerologyFinal Report里的珠盘, switch toDIY Studio同一张裁剪后的Wood珠盘图片, 
            // 并叠加同一层统一盘口高光/Yin影, 跟DIY Studio完全一致 (之前这里漏了盘口这层, 
            // 单独只写了Wood纹图, 看起来才会像没有盘口边缘) 
            const plateImg = 'var(--plate-rim-ring), var(--plate-wood-img)';
            // 手链贴合珠盘摆放, 按真实beadsize累计周长贴合排布
            const layout = computeRingLayout(beads, cx, cy, 0.82, trayW / 2 * 0.82, trayH / 2 * 0.82);
            const threadW = layout.rx * 2 + 6,
                threadH = layout.ry * 2 + 6;
            let ring = `<div class="fr-tray-wrap"><div class="fr-tray" style="width:${trayW}px;height:${trayH}px;background-image:${plateImg};background-size:cover,cover;background-position:center,center;background-repeat:no-repeat,no-repeat;">
                <div class="fr-tray-logo">Star Energy<br>Handcrafted</div>
                <div class="fr-thread-ring" style="width:${threadW}px;height:${threadH}px;left:${cx-threadW/2}px;top:${cy-threadH/2}px;"></div>`;
            beads.forEach((b, i) => {
                const pos = layout.positions[i];
                const cls = (b.role === 'spacer' || b.size === 'metal') ? 'fr-bead fr-bead-spacer' : 'fr-bead';
                const beadImgVar = getBeadImgVar(b);
                ring += `<div class="${cls}" style="left:${(pos.x-pos.size/2).toFixed(1)}px;top:${(pos.y-pos.size/2).toFixed(1)}px;width:${pos.size.toFixed(1)}px;height:${pos.size.toFixed(1)}px;--bead-color:${b.color};--bead-img:${beadImgVar};" title="${b.name}"></div>`;
            });
            ring += `</div></div>`;
            const snapshotWristCm = currentSuggestWristCm();
            const caption = `Wooden tray display · ${beads.length} 10cm stretch-cord beads, estimated wrist size about ${snapshotWristCm.toFixed(1)}cm, a daily-wear piece auto-generated by Five Elements destiny and Feng Shui to improve wealth and health — order directly from the cart below · or click "DIY Studio" to customize freely.`;
            return `<div class="fr-summary">${buildCompositionSummaryText()}</div>${ring}<div class="fr-caption">${caption}</div>`;
        }

        // ============================================================
        //  11. 素材management
        // ============================================================
        function renderMaterials() {
            const grid = document.getElementById('materialGrid');
            if (!grid) return;
            const cat = appState.activeCat || 'all';
            const items = MATERIALS[cat] || [];
            let html = '';
            items.forEach((item) => {
                const inBracelet = appState.beads.some(b => b.name === item.name && b.color === item.color);
                const fit = getFit(item.wx);
                const fitClass = fit === 'Recommended' ? 'fit-good' : fit === 'Use with Caution' ? 'fit-bad' : 'fit-neutral';
                const imgVar = getBeadImgVar(item);
                html += `
                    <div class="mat-item ${inBracelet ? 'recommended' : ''}" onclick="addMaterial('${cat}', '${item.name}')">
                        <div class="mat-color" style="--bead-color:${item.color};--bead-img:${imgVar};"></div>
                        <div class="mat-name">${item.name}</div>
                        <div class="mat-price">${item.currency || '$'}${item.price}</div>
                        <div class="mat-tag">${item.tag}</div>
                        <div class="mat-fit ${fitClass}">${fit}</div>
                    </div>
                `;
            });
            grid.innerHTML = html;
        }

        function getFit(wx) {
            if (!wx) return 'Neutral';
            if (appState.xiList.includes(wx)) return 'Recommended';
            if (appState.jiList.includes(wx)) return 'Use with Caution';
            return 'Neutral';
        }

        function addMaterial(cat, name) {
            const items = MATERIALS[cat] || [];
            const item = items.find(i => i.name === name);
            if (!item) return;
            const maxBeads = appState.targetBeadCount || 18;
            if (appState.beads.length >= maxBeads) { showToast(`Maximum ${maxBeads} beads — switch to a higher lucky count above if you need more`); return; }
            const role = ['main', 'second', 'wealth', 'marriage', 'health', 'study', 'spacer'].includes(cat) ?
                cat : (item.tag === 'gold' || item.tag === 'silver' ? 'spacer' : 'main');
            appState.beads.push({ ...item, role, _x: undefined, _y: undefined });
            soundAdd();
            renderBeads();
            renderMaterials();
            setTimeout(() => {
                const beads = document.querySelectorAll('#beadContainer .bead');
                if (beads.length > 0) flashBead(beads[beads.length - 1]);
            }, 100);
            showToast(`➕ Added  ${item.name} (${getFit(item.wx)})`);
        }

        // ============================================================
        //  12. 分类与 style切换
        // ============================================================
        function switchCategory(cat) {
            document.querySelectorAll('.category-side .cat-item').forEach(el => {
                el.classList.toggle('active', el.dataset.cat === cat);
            });
            appState.activeCat = cat || 'all';
            renderMaterials();
        }

        function switchPlateStyle(style) {
            appState.plateStyle = style;
            const wrap = document.getElementById('plateWrap');
            if (!wrap) return;
            wrap.className = 'bead-plate-wrap plate-style-' + style;
            document.querySelectorAll('.style-btn').forEach(btn => {
                btn.classList.toggle('active', btn.dataset.style === style);
            });
            showToast(`🎨 Switched to  ${style}  style`);
        }

        // ============================================================
        //  13. Profile - Edit Profile
        // ============================================================
        function openProfileModal() {
            document.getElementById('editAvatar').value = appState.profile.avatar || '🧑';
            document.getElementById('editName').value = appState.profile.name || 'Star User';
            document.getElementById('editEmail').value = appState.profile.email || 'user@example.com';
            document.getElementById('profileModal').classList.add('open');
        }

        function closeProfileModal() {
            document.getElementById('profileModal').classList.remove('open');
        }

        function saveProfile() {
            const avatar = document.getElementById('editAvatar').value.trim() || '🧑';
            const name = document.getElementById('editName').value.trim() || 'Star User';
            const email = document.getElementById('editEmail').value.trim() || 'user@example.com';
            appState.profile = { avatar, name, email };
            document.getElementById('profileAvatar').textContent = avatar;
            document.getElementById('profileName').textContent = name;
            document.getElementById('profileEmail').textContent = email;
            closeProfileModal();
            showToast('✅ Profile updated');
        }

        // ============================================================
        //  14. 初始化
        // ============================================================
        document.addEventListener('DOMContentLoaded', function() {
            setupBeadDrag();
            document.querySelectorAll('.nav-tabs .tab-item').forEach(tab => {
                tab.addEventListener('click', function() {
                    const page = this.dataset.tab;
                    if (page === 'cart') { toggleCart(); return; }
                    navigateTo(page);
                });
            });

            document.querySelectorAll('.category-side .cat-item').forEach(btn => {
                btn.addEventListener('click', function() {
                    document.querySelectorAll('.category-side .cat-item').forEach(b => b.classList.remove(
                        'active'));
                    this.classList.add('active');
                    renderMaterials();
                });
            });

            document.getElementById('wristSize').addEventListener('input', function() {
                // wrist size改了, Suggested Wrist与bead大小Advice都要同步刷新
                updateWristAdvice();
            });

            document.getElementById('profileModal').addEventListener('click', function(e) {
                if (e.target === this) closeProfileModal();
            });

            window.navigateTo = navigateTo;
            window.toggleCart = toggleCart;
            window.runEnergyTest = runEnergyTest;
            window.toggleCollapse = toggleCollapse;
            window.scatterBeads = scatterBeads;
            window.inspireBeads = inspireBeads;
            window.removeBead = removeBead;
            window.undoBead = undoBead;
            window.clearBeads = clearBeads;
            window.saveBracelet = saveBracelet;
            window.addMaterial = addMaterial;
            window.checkout = checkout;
            window.updateQty = updateQty;
            window.removeFromCart = removeFromCart;
            window.addDiyCart = addDiyCart;
            window.addReportToCart = addReportToCart;
            window.trackOrdersByEmail = trackOrdersByEmail;
            window.switchPlateStyle = switchPlateStyle;
            window.switchCategory = switchCategory;
            window.addMoneyTreeToCart = addMoneyTreeToCart;
            window.switchProductCat = switchProductCat;
            window.unlockReport = unlockReport;
            window.openProfileModal = openProfileModal;
            window.closeProfileModal = closeProfileModal;
            window.saveProfile = saveProfile;

            setTimeout(() => {
                runEnergyTest();
            }, 200);

            renderMaterials();
            renderBeads();
            updateCartUI();

            console.log('✨ Fortune Stone · Star Energy (PC) loaded');
        });